import DataGrid, {
    Column,
    ColumnChooser,
    Export,
    FilterRow,
    Grouping,
    GroupPanel,
    HeaderFilter,
    Scrolling,
    SearchPanel,
    Selection,
    Paging,
} from 'devextreme-react/data-grid';
import { Template } from 'devextreme-react/core/template';
import DropDownBox from 'devextreme-react/drop-down-box';
import { SelectBox } from 'devextreme-react/select-box';
import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { NavItem, NavLink } from 'reactstrap';
import Swal from 'sweetalert2';
import { Popup } from 'devextreme-react/popup';
import { Workbook } from 'exceljs'; //npm i exceljs
import { saveAs } from 'file-saver-es';  //npm i file-saver-es
import { exportDataGrid } from 'devextreme/excel_exporter';
import moment from 'moment/min/moment-with-locales';
import { DispatchSocketService } from './DispatchSocketService';

import { DateFormat, StatusType, TripStatus } from '../../helpers/fixcodes';
import { formatDate, formatTime, formatFromDate, formatToDate, formatSearchDate, getRequestParams } from '../../helpers/globalfunctions';
import { LocateVehicleComponent } from '../Shared/LocateVehicleComponent';
import { NoShowReservationsComponent } from '../NoShow/NoShowReservationsComponent';
import { NotificationComponent } from '../Shared/NotificationComponent';
import { ReservationHistoryComponent } from '../Shared/ReservationHistoryComponent';
import { SendMessageComponent } from '../Shared/SendMessageComponent';
import { ViewReservationComponent } from '../Shared/ViewReservationComponent';
import { LoadingPopupComponent } from '../Shared/LoadingPopupComponent';
import { DispatchDetailComponent } from './DispatchDetailComponent';
import { SendAirlineCrewMessageComponent } from '../Shared/SendAirlineCrewMessageComponent'
import DispatchFilterBar from './DispatchFilterBar';
import DispatchGrid from './DispatchGrid';
import * as CellRenderers from './DispatchCellRenderers';
import { ClubReservationsComponent } from './ClubReservationsComponent';

export const reservationList = [];
let currentTime = sessionStorage.getItem("session_locationTime") == "" ? new Date() : new Date(sessionStorage.getItem("session_locationTime"));

const dispatchDisplayDurationMin = parseInt(sessionStorage.getItem("session_dispatchDisplayDurationMin"));
const dispatchDisplayDurationMax = parseInt(sessionStorage.getItem("session_dispatchDisplayDurationMax"));
const allowToAddDriverWorkingHours = sessionStorage.getItem("session_allowToAddDriverWorkingHours");
const dispatchRefreshInterval = parseInt(sessionStorage.getItem("session_dispatchRefreshInterval"));
const session_accountId = parseInt(sessionStorage.getItem("session_accountId"));
const session_mappedAccountId1 = parseInt(sessionStorage.getItem("session_mappedAccountId1"));
const session_mappedAccountId2 = parseInt(sessionStorage.getItem("session_mappedAccountId2"));
const session_mappedAccountId4 = parseInt(sessionStorage.getItem("session_mappedAccountId4"));
const session_mappedAccountId5 = parseInt(sessionStorage.getItem("session_mappedAccountId5"));
const session_mappedAccountId6 = parseInt(sessionStorage.getItem("session_mappedAccountId6"));
const session_mappedAccountId7 = parseInt(sessionStorage.getItem("session_mappedAccountId7"));
const session_dispatchDisplayDurationMinSec = parseInt(sessionStorage.getItem("session_dispatchDisplayDurationMinSec"));
const session_dispatchDisplayDurationMaxSec = parseInt(sessionStorage.getItem("session_dispatchDisplayDurationMaxSec"));
const session_menuAccess = JSON.parse(sessionStorage.getItem("session_menu"));
let startTime = new Date(new Date(currentTime).setDate(currentTime.getDate() - dispatchDisplayDurationMin));
let endTime = new Date(new Date(currentTime).setDate(currentTime.getDate() + dispatchDisplayDurationMax));
let currentDate = formatDate("MM/dd/yyyy", sessionStorage.getItem("session_locationTime") == "" ? new Date() : new Date(sessionStorage.getItem("session_locationTime")));

let driverWorkingHoursobject = [
    { id: 1, name: "1" },
    { id: 2, name: "2" },
    { id: 3, name: "3" },
    { id: 4, name: "4" },
    { id: 5, name: "5" },
    { id: 6, name: "6" },
    { id: 7, name: "7" },
    { id: 8, name: "8" },
    { id: 9, name: "9" },
    { id: 10, name: "10" },
    { id: 11, name: "11" },
    { id: 12, name: "12" },
]

const DISPATCH_CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes

// Mapped accounts get the 'custom' DispatchGrid (dispatch-grid-container-custom); everyone else the 'standard' one.
function isCustomDispatchGrid() {
    return !(session_mappedAccountId1 !== session_accountId
        && session_mappedAccountId2 !== session_accountId
        && session_mappedAccountId4 !== session_accountId
        && session_mappedAccountId5 !== session_accountId
        && session_mappedAccountId6 !== session_accountId
        && session_mappedAccountId7 !== session_accountId);
}

// Maximum number of rides a dispatcher can select at once in the custom grid (Club Reservation(s) needs at least 2).
const MAX_SELECTED_RIDES = 3;

// Same fixed 6-hour pickup-time slots as SgDispatchComponent. Bounds are inclusive of seconds
// (e.g. slot 1 ends at 05:59:59) so filtering matches pickupDateTime down to the second.
const PICKUP_TIME_SLOTS = [
    { id: 1, label: '12 AM - 6 AM', startSeconds: 0 * 3600, endSeconds: 6 * 3600 - 1 },
    { id: 2, label: '6 AM - 12 PM', startSeconds: 6 * 3600, endSeconds: 12 * 3600 - 1 },
    { id: 3, label: '12 PM - 6 PM', startSeconds: 12 * 3600, endSeconds: 18 * 3600 - 1 },
    { id: 4, label: '6 PM - 12 AM', startSeconds: 18 * 3600, endSeconds: 24 * 3600 - 1 },
];

// Crew Type filter options, shaped like the ride's own paxTypeCode/paxType properties:
// paxTypeCode is the SelectBox value member, paxType its display member.
const CREW_TYPES = [
    { paxTypeCode: 'P', paxType: 'Cockpit Crew' },
    { paxTypeCode: 'C', paxType: 'Cabin Crew' },
];

function readCache(key) {
    try {
        const raw = sessionStorage.getItem(key);
        if (!raw) return null;
        const { data, ts } = JSON.parse(raw);
        if (Date.now() - ts > DISPATCH_CACHE_TTL_MS) {
            sessionStorage.removeItem(key);
            return null;
        }
        return data;
    } catch {
        return null;
    }
}

function writeCache(key, data) {
    try {
        sessionStorage.setItem(key, JSON.stringify({ data, ts: Date.now() }));
    } catch {
        // sessionStorage quota exceeded — skip caching silently
    }
}

export class DispatchComponent extends Component {
    static displayName = DispatchComponent.name;

    constructor(props) {
        currentTime = sessionStorage.getItem("session_locationTime") == "" ? new Date() : new Date(sessionStorage.getItem("session_locationTime"));
        currentDate = formatDate(sessionStorage.getItem("session_locationTime") == "" ? new Date() : new Date(sessionStorage.getItem("session_locationTime")), "MM/dd/yyyy");
        startTime = moment(currentDate, "MM-DD-YYYY HH:mm").subtract(dispatchDisplayDurationMin, 'days').format("MM/DD/YYYY HH:mm");
        endTime = moment(currentDate, "MM-DD-YYYY HH:mm").add(dispatchDisplayDurationMax, 'days').format("MM/DD/YYYY HH:mm");
        startTime = moment(startTime, "MM-DD-YYYY HH:mm").add(session_dispatchDisplayDurationMinSec, 'minutes').format("MM/DD/YYYY HH:mm");
        endTime = moment(endTime, "MM-DD-YYYY HH:mm").add(session_dispatchDisplayDurationMaxSec, 'minutes').format("MM/DD/YYYY HH:mm");

        super(props);

        this.selectionChangedBySelectBox = false;
        this.state = {
            // --- Loading / submission ---
            isSubmited: false,
            isAdvancedSubmited: false,
            isPageLoading: true,
            isSearchLoading: false,
            isAlertLoading: false,
            loadPanelEnabled: true,
            loadPanelVisible: false,

            // --- Grid data ---
            reservationGridDataSource: null,
            alertNotificationsSource: null,
            refreshDataSource: null,
            isGridHasRow: false,
            totalRideCount: 0,
            originalRideCount: 0,

            // --- Lookup / reference data ---
            statusList: [],
            vehicleGroupTypesList: [],
            filterVehicleGroupTypeList: [],
            vehicleTypeList: [],
            filterVehicleTypeList: [],
            filterVehicleList: [],
            serviceVehicles: [],
            serviceDrivers: [],
            vehicleList: [],
            driverList: [],
            locationList: [],
            driverWorkingHours: driverWorkingHoursobject,

            // --- Search filters ---
            isLive: false,
            isInHouse: false,
            isFarmIn: false,
            isFarmOut: false,
            // "All" is checked by default; like handleInputChange, it's exclusive with the other status chips.
            isShowCompleted: false,
            isShowCancelled: false,
            isShowPending: false,
            isShowPickupSchedules: true,
            isShowInProcess: false,
            isShowAll: true,
            isVisiblePickupSchedules: parseInt(sessionStorage.getItem("session_accountId")) === 6052 ? true : false,
            gridBoxVehicleTypeValue: [],
            searchFromDate: formatFromDate(startTime, "MM/dd/yyyy hh:mm"),
            searchToDate: formatToDate(endTime, "MM/dd/yyyy hh:mm"),
            searchToGpsDate: formatFromDate(new Date(new Date(currentTime).setDate(currentTime.getDate() + 0)), "MM/dd/yyyy hh:mm"),
            rideId: "",
            vehicleTypeId: 0,
            statusId: 0,
            locationId: 0,
            vehicleId: 0,
            driverId: 0,
            dateRange: "Date Range: " + formatFromDate(startTime, "MM/dd/yyyy hh:mm") + " to " + formatToDate(endTime, "MM/dd/yyyy hh:mm"),
            isSearch: false,

            // --- Auto-refresh ---
            seconds: dispatchRefreshInterval,
            isStopAutoRefresh: false,
            isRestartRefresh: false,

            // --- Dispatch assignment ---
            dispatchVehicleId: 0,
            dispatchDriverId: 0,
            isVehicleMultipleAssignedSubmited: false,
            isVehicleMultipleUnAssignedSubmited: false,
            isRideMultipleAttendSubmited: false,
            selectedRowKeys: [],
           
            isUnclubReservationsSubmitted: false,
            // Custom grid toolbar filters (see _buildGridFilter)
            selectedPickupTimeSlotId: null,
            selectedCrewTypeId: null,
            driverWorkingHoursId: 0,
            driverWorkingHoursValue: "0",
            errors: {
                dispatchVehicleId: 0,
                dispatchDriverId: 0,
            },

            // --- UI config ---
            trackmapUrl: "",
            callNoshowReservation: props.displayHeader,
            isExportToReport: false,
            wsurl: sessionStorage.getItem("session_socketApiUrl"),
            allowSocketConnection: sessionStorage.getItem("session_allowSocketConnection") === "true" ? true : false,
            isShowAlertNotificationsAll: false,
            isShowDispatchFilter: true,
            menuAccess: session_menuAccess,
            allowNewReservation: false,
            allowSearchReservation: false,
            gridSearchText: '',

            // --- Address popup ---
            addressPopupVisible: false,
            addressPopupText: '',
            addressPopupTitle: '',

            // --- Socket update indicator ---
            socketDataUpdated: false,
        }

        this.socketService = null;
        this._socketUpdateTimer = null;
        this._rideStore = null;
        this._rideDataSource = null;
        this.countdownInterval = null;
        this.getPreApprovedRideList = this.getPreApprovedRideList.bind(this);
        this.getStatusList = this.getStatusList.bind(this);
        this.getLocationList = this.getLocationList.bind(this);
        this.getVehicleGroupTypeList = this.getVehicleGroupTypeList.bind(this);
        this.getVehicleTypeList = this.getVehicleTypeList.bind(this);
        this.getVehiclesList = this.getVehiclesList.bind(this);
        this.getDriversList = this.getDriversList.bind(this);
        this.renderDetail = this.renderDetail.bind(this);
        this.enterKeyActionChanged = this.enterKeyActionChanged.bind(this);
        this.getMapUrl = this.getMapUrl.bind(this);

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleVehicleTypeChange = this.handleVehicleTypeChange.bind(this);
        this.handleLocationChange = this.handleLocationChange.bind(this);
        this.handleVehicleGroupTypeChange = this.handleVehicleGroupTypeChange.bind(this);
        this.handleVehicleChange = this.handleVehicleChange.bind(this);
        this.handleDriverChange = this.handleDriverChange.bind(this);
        this.handleSearchFromDateChange = this.handleSearchFromDateChange.bind(this);
        this.handleSearchToDateChange = this.handleSearchToDateChange.bind(this);
        this.sortByKeyAsc = this.sortByKeyAsc.bind(this);
        this.handleDispatchVehicleChange = this.handleDispatchVehicleChange.bind(this);
        this.handleDispatchDriverChange = this.handleDispatchDriverChange.bind(this);
        this.handleMultipleJobAssign = this.handleMultipleJobAssign.bind(this);
        this.handleMultipleJobAttend = this.handleMultipleJobAttend.bind(this);
        this.handleMultipleJobUnAssign = this.handleMultipleJobUnAssign.bind(this);
        this.handleMultipleRideSelectionChanged = this.handleMultipleRideSelectionChanged.bind(this);
        this.rowClick = this.rowClick.bind(this);
        this.handleCellPrepared = this.handleCellPrepared.bind(this);
        this.toolbarItemRender = this.toolbarItemRender.bind(this);
        this.toolbarAlertNotificationItemRender = this.toolbarAlertNotificationItemRender.bind(this);

        this.syncDataGridVehicleGroupSelection = this.syncDataGridVehicleGroupSelection.bind(this);
        this.dataGridVehicleGroupRender = this.dataGridVehicleGroupRender.bind(this);
        this.syncDataGridVehicleTypeSelection = this.syncDataGridVehicleTypeSelection.bind(this);
        this.dataGridVehicleTypeRender = this.dataGridVehicleTypeRender.bind(this);
        this.syncDataGridVehicleSelection = this.syncDataGridVehicleSelection.bind(this);
        this.dataGridVehicleRender = this.dataGridVehicleRender.bind(this);
        //this.setDisplayHeaderValue = this.setDisplayHeaderValue.bind(this);

        this.handleSearch = this.handleSearch.bind(this);
        this.handleDispatchSearch = this.handleDispatchSearch.bind(this);
        this.handleDaySearch = this.handleDaySearch.bind(this);
        this.handleRowPrepared = this.handleRowPrepared.bind(this);
        this.handleCustomRowPrepared = this.handleCustomRowPrepared.bind(this);
        this.handleClearSearch = this.handleClearSearch.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
        this.prevDate = this.prevDate.bind(this);
        this.nextDate = this.nextDate.bind(this);

        this.openViewReservationModel = this.openViewReservationModel.bind(this);
        this.openReservationHistoryModel = this.openReservationHistoryModel.bind(this);
        this.updateVehicleEtdEta = this.updateVehicleEtdEta.bind(this);
        // this.rowChanged = this.rowChanged.bind(this);
        this.editViewRide = this.editViewRide.bind(this);
        this.refreshDispatch = this.refreshDispatch.bind(this);
        this.sendDriverMessageControl = this.sendDriverMessageControl.bind(this);
        this.sendCrewAirlineMessageControl = this.sendCrewAirlineMessageControl.bind(this);
        this.handleNoshowReservations = this.handleNoshowReservations.bind(this);
        this.onExporting = this.onExporting.bind(this);
        this.readNotification = this.readNotification.bind(this);
    }

    async componentDidMount() {
        const _mountStart = performance.now();

        // Load status list first — getPreApprovedRideList filters rides by statusList
        await this.getStatusList();

        if (this.props.location.state != undefined) {
            await new Promise(resolve => this.setState({
                isLive: this.props.location.state.isLive,
                isInHouse: this.props.location.state.isInHouse,
                isFarmIn: this.props.location.state.isFarmIn,
                isFarmOut: this.props.location.state.isFarmOut,
                searchFromDate: this.props.location.state.searchFromDate,
                searchToDate: this.props.location.state.searchToDate,
                seconds: this.props.location.state.seconds,
                rideId: this.props.location.state.rideId,
                filterVehicleGroupTypeList: this.props.location.state.filterVehicleGroupTypeList,
                filterVehicleTypeList: this.props.location.state.filterVehicleTypeList,
                locationId: this.props.location.state.locationId,
                filterVehicleList: this.props.location.state.filterVehicleList,
            }, resolve));
            // Ride list + all remaining lookups in parallel
            await Promise.all([
                this.handleSearch(),
                this.getVehiclesList(),
                this.getDriversList(),
                this.getVehicleGroupTypeList(),
                this.getVehicleTypeList(),
                this.getLocationList(),
                this.getMapUrl(),
            ]);
        } else {
            await new Promise(resolve => this.setState({
                searchFromDate: formatFromDate(this.state.searchFromDate, "MM/dd/yyyy hh:mm"),
                searchToDate: formatToDate(this.state.searchToDate, "MM/dd/yyyy hh:mm")
            }, resolve));
            // Ride list + all remaining lookups in parallel
            await Promise.all([
                this.getPreApprovedRideList(),
                this.getVehiclesList(),
                this.getDriversList(),
                this.getVehicleGroupTypeList(),
                this.getVehicleTypeList(),
                this.getLocationList(),
                this.getMapUrl(),
            ]);
        }

        if (this.state.menuAccess !== null) {
            if (this.state.menuAccess.filter((e) => e.menuName === "Search Reservation").length > 0) {
                this.setState({ allowNewReservation: true });
            }
        }

        if (this.state.menuAccess !== null) {
            if (this.state.menuAccess.filter((e) => e.menuName === "New Reservation").length > 0) {
                this.setState({ allowSearchReservation: true });
            }
        }

        if (this.state.allowSocketConnection) {
            this.socketService = new DispatchSocketService(this.state.wsurl, this.onStatusUpdateBindTripData);
            this.socketService.connect();
        }

        if (!this.state.allowSocketConnection) {
            this.startAutoRefresh();
        }

        //await this.getAlertNotifications(false);
        //await this.getPreApprovedRideList();
        //await this.getPreApprovedGpsRideList();
        await Promise.all([
            this.getVehiclesList(),
            this.getDriversList(),
            this.getVehicleGroupTypeList(),
            this.getVehicleTypeList(),
            this.getLocationList(),
            this.getMapUrl(),
        ]);

        //this.setState({
        //    loadPanelVisible: false
        //})
        console.log(`[DispatchComponent] Page load complete in ${((performance.now() - _mountStart) / 1000).toFixed(2)} s`);
    }

    componentWillUnmount() {
        clearInterval(this.dispatchInterval);
        clearInterval(this.dispatchIntervalHandle);
        clearInterval(this.countdownInterval);
        if (this._socketUpdateTimer) clearTimeout(this._socketUpdateTimer);
        if (this.socketService) this.socketService.disconnect();
    }

    startAutoRefresh() {
        clearInterval(this.dispatchInterval);
        clearInterval(this.countdownInterval);
        this.setState({ seconds: dispatchRefreshInterval });
        this.dispatchInterval = setInterval(async () => {
            await this.handleSearch();
        }, dispatchRefreshInterval * 1000);
        this.countdownInterval = setInterval(() => {
            this.setState(prev => ({
                seconds: prev.seconds > 0 ? prev.seconds - 1 : 0
            }));
        }, 1000);
    }

    sendDriverMessageControl(e, data) {
        e.preventDefault();
        clearInterval(this.dispatchInterval);
        clearInterval(this.dispatchIntervalHandle);
        clearInterval(this.countdownInterval);
        this.refs.SendMessageComponentModel.showModal(data);
    }

    sendCrewAirlineMessageControl(e, data) {
        e.preventDefault();
        clearInterval(this.dispatchInterval);
        clearInterval(this.dispatchIntervalHandle);
        clearInterval(this.countdownInterval);
        this.refs.SendAirlineCrewMessageComponentModel.showAirlineCrewMessageModal(data);
    }

    handleNoshowReservations(e, data) {
        e.preventDefault();
        this.refs.noShowReservations.callNoshowReservation();
    }


    _initDataSource = (rides) => {
        this._rideStore = new ArrayStore({ key: 'rideId', data: rides ? [...rides] : [] });
        // Carry the toolbar filters over so they survive a Search/Refresh/auto-refresh reload.
        this._rideDataSource = new DataSource({ store: this._rideStore, reshapeOnPush: true, filter: this._buildGridFilter() });
    }

    // Client-side Pickup Time / Crew Type filter for the custom grid, as a DataSource filter
    // function (null when neither is selected). Reads state directly, so it must be called
    // after the setState that changes the selection has been applied.
    _buildGridFilter = (pickupTimeSlotId = this.state.selectedPickupTimeSlotId, crewTypeId = this.state.selectedCrewTypeId) => {
        const slot = pickupTimeSlotId ? PICKUP_TIME_SLOTS.find(s => s.id === pickupTimeSlotId) : null;
        if (!slot && !crewTypeId) {
            return null;
        }
        return (r) => {
            if (slot) {
                if (!r.pickupDateTime) {
                    return false;
                }
                const d = new Date(r.pickupDateTime);
                const seconds = d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds();
                if (seconds < slot.startSeconds || seconds > slot.endSeconds) {
                    return false;
                }
            }
            if (crewTypeId) {
                // Lowercase both sides so "P"/"p" and "C"/"c" match. Rides carry the code in paxTypeCode;
                // paxType ("P"/"C") is checked too so rides without a paxTypeCode still filter correctly.
                const selectedCode = crewTypeId.toLowerCase();
                const rideCodes = [r.paxTypeCode, r.paxType].map(v => (v || '').trim().toLowerCase());
                if (!rideCodes.includes(selectedCode)) {
                    return false;
                }
            }
            return true;
        };
    }

    _applyGridFilters = () => {
        if (!this._rideDataSource) {
            return;
        }
        this._rideDataSource.filter(this._buildGridFilter());
        this._rideDataSource.load().then(() => {
            // Same count refresh as handleOptionChange, once the grid has re-rendered the filtered rows.
            setTimeout(() => {
                if (this.dataGrid && this.dataGrid.instance) {
                    const count = this.dataGrid.instance.totalCount();
                    this.setState({ totalRideCount: count, isGridHasRow: count > 0 });
                }
            }, 0);
        });
    }

    handlePickupTimeSlotChange = (e) => {
        this.setState({ selectedPickupTimeSlotId: e.selectedItem ? e.selectedItem.id : null }, this._applyGridFilters);
    }

    handleCrewTypeChange = (e) => {
        this.setState({ selectedCrewTypeId: e.selectedItem ? e.selectedItem.paxTypeCode : null }, this._applyGridFilters);
    }

    renderFilterToolbarItems = () => {
        return (
            <div className="d-flex align-items-center">
                <label htmlFor="dispatch-pickup-timeslot-dropdown" className="mr-2 mb-0" style={{ fontWeight: 600 }}>Pickup Time</label>
                <SelectBox
                    id="dispatch-pickup-timeslot-dropdown"
                    dataSource={PICKUP_TIME_SLOTS}
                    value={this.state.selectedPickupTimeSlotId}
                    displayExpr="label"
                    valueExpr="id"
                    placeholder="Filter by Pickup Time"
                    showClearButton={true}
                    width={200}
                    onSelectionChanged={this.handlePickupTimeSlotChange}
                />
                &nbsp;
                <label htmlFor="dispatch-crew-type-dropdown" className="ml-2 mr-2 mb-0" style={{ fontWeight: 600 }}>Crew Type</label>
                <SelectBox
                    id="dispatch-crew-type-dropdown"
                    dataSource={CREW_TYPES}
                    value={this.state.selectedCrewTypeId}
                    displayExpr="paxType"
                    valueExpr="paxTypeCode"
                    placeholder="Filter by Crew Type"
                    showClearButton={true}
                    width={180}
                    onSelectionChanged={this.handleCrewTypeChange}
                />
            </div>
        );
    }

    // Custom grid: strip the header "select all" checkbox — the max-selection and same-ride-type
    // rules make a blanket select-all meaningless, and allowSelectAll={false} alone still leaves
    // the checkbox rendered (just inert). Same approach as SgDispatchComponent.onCellPrepared.
    handleCustomCellPrepared = (e) => {
        if (e.rowType === 'header' && e.column && e.column.command === 'select') {
            e.cellElement.innerHTML = '';
        }
        // Completed / No Show rides: show the row checkbox as disabled so it can't be clicked.
        if (e.rowType === 'data' && e.column && e.column.command === 'select' && this.isCompletedTrip(e.data)) {
            e.cellElement.style.pointerEvents = 'none';
            e.cellElement.style.opacity = '0.4';
            e.cellElement.title = 'No Show / Completed rides can\'t be selected';
        }
    }

    onStatusUpdateBindTripData = (tripData) => {
        try {
            if (this.state.reservationGridDataSource === null) return;
            this._applySocketUpdate(tripData);
        } catch (e) {
            console.log("Error in " + this.displayName + ".onStatusUpdateBindTripData function", e);
        }
    }

    _applySocketUpdate = (tripData) => {
        try {
            if (!this._rideStore) return;

            const removedStatuses = [
                parseInt(TripStatus.COMPLETED),
                parseInt(TripStatus.CANCELLED),
                parseInt(TripStatus.PAXUNLOAD),
            ];

            if (removedStatuses.includes(parseInt(tripData.TripStatusId))) {
                // Remove the row from the store — no React re-render triggered
                this._rideStore.push([{ type: 'remove', key: tripData.RideId }]);
            } else if (tripData.DispatchReservationResponse != undefined) {
                const updatedRide = tripData.DispatchReservationResponse.DispatchReservations[0];
                if (updatedRide == undefined) return;
                // Push full field update for the affected row only
                this._rideStore.push([{
                    type: 'update', key: tripData.RideId, data: {
                        isSelected: updatedRide.IsSelected,
                        reservationId: updatedRide.ReservationId,
                        rideId: updatedRide.RideId,
                        customerTypeId: updatedRide.CustomerTypeId,
                        customerTypeName: updatedRide.CustomerTypeName,
                        accountCode: updatedRide.AccountCode,
                        flightInfo: updatedRide.FlightInfo,
                        flightTime: updatedRide.FlightTime,
                        flightETA: updatedRide.FlightETA,
                        flightATA: updatedRide.FlightATA,
                        flightSTA: updatedRide.FlightSTA,
                        flightStatus: updatedRide.FlightStatus,
                        flightTerminal: updatedRide.FlightTerminal,
                        flightGate: updatedRide.FlightGate,
                        flightCommentStatus: updatedRide.FlightCommentStatus,
                        paxName: updatedRide.PaxName,
                        puStreet: updatedRide.PuStreet,
                        doStreet: updatedRide.DoStreet,
                        pickupDateTime: updatedRide.PickupDateTime,
                        tempPickupDateTime: updatedRide.TempPickupDateTime,
                        assignedTime: updatedRide.AssignedTime,
                        acceptedTime: updatedRide.AcceptedTime,
                        onLocationTime: updatedRide.OnLocationTime,
                        onLoadTime: updatedRide.OnLoadTime,
                        onUnloadTime: updatedRide.OnUnloadTime,
                        onCompletedTime: updatedRide.OnCompletedTime,
                        noOfAdults: updatedRide.NoOfAdults,
                        permanentRemark: updatedRide.PermanentRemark,
                        specialInsruction: updatedRide.SpecialInsruction,
                        driverId: updatedRide.DriverId,
                        driverUserName: updatedRide.DriverUserName,
                        driverName: updatedRide.DriverName,
                        driverMobileNo: updatedRide.DriverMobileNo,
                        dispatcherName: updatedRide.DispatcherName,
                        vehicleId: updatedRide.VehicleId,
                        vehicleNo: updatedRide.VehicleNo,
                        vehicleTypeId: updatedRide.VehicleTypeId,
                        vehicleTypeName: updatedRide.VehicleTypeName,
                        vehicleTypeDescription: updatedRide.VehicleTypeDescription,
                        sharedType: updatedRide.SharedType,
                        tripStatusId: updatedRide.TripStatusId,
                        tripStatusDesc: updatedRide.TripStatusDesc,
                        isPreAssignedRide: updatedRide.IsPreAssignedRide,
                        parentRideId: updatedRide.ParentRideId,
                        noOfCharter: updatedRide.NoOfCharter,
                        meetGreetName: updatedRide.MeetGreetName,
                        meetGreetCharge: updatedRide.MeetGreetCharge,
                        meetGreetAmount: updatedRide.MeetGreetAmount,
                        isVIP: updatedRide.IsVIP,
                        paymentTypeId: updatedRide.PaymentTypeId,
                        paymentTypeName: updatedRide.PaymentTypeName,
                        jobId: updatedRide.JobId,
                        preAssignedAcknowledgeStatus: updatedRide.PreAssignedAcknowledgeStatus,
                        preAssignedAcknowledgeDate: updatedRide.PreAssignedAcknowledgeDate,
                        preAssignedAcknowledgeByDriver: updatedRide.PreAssignedAcknowledgeByDriver,
                        spInfo: updatedRide.SpInfo,
                        isVIPStatus: updatedRide.IsVIPStatus,
                        wait: updatedRide.Wait,
                        priority: updatedRide.Priority,
                        accessibility: updatedRide.Accessibility,
                        leadTime: updatedRide.LeadTime,
                        paxFirstName: updatedRide.PaxFirstName,
                        paxLastName: updatedRide.PaxLastName,
                        bdo: updatedRide.Bdo,
                        isBaggage: updatedRide.IsBaggage,
                        exceededBoardedTime: updatedRide.ExceededBoardedTime,
                        icaoFlightNumber: updatedRide.IcaoFlightNumber,
                        preAssignedAcknowledgeId: updatedRide.PreAssignedAcknowledgeId,
                        airlineLogoUrl: updatedRide.AirlineLogoUrl,
                        vehicleEtaEtd: updatedRide.VehicleEtaEtd,
                        isVehicleDeviceMapped: updatedRide.IsVehicleDeviceMapped,
                        etaEtdMessage: updatedRide.EtaEtdMessage,
                        lastRefreshTime: updatedRide.LastRefreshTime,
                        vehicleDistance: updatedRide.VehicleDistance,
                        hasAttachment: updatedRide.HasAttachment,
                        allowClubbing: updatedRide.AllowClubbing,
                        driverWorkingHours: updatedRide.DriverWorkingHours,
                        trackingSourceId: updatedRide.TrackingSourceId,
                        airlineCode: updatedRide.AirlineCode,
                        createdDateTime: updatedRide.CreatedDateTime,
                        flightDateTime: updatedRide.FlightDateTime,
                        displayDayDifference: updatedRide.DisplayDayDifference,
                        paxTypeCode: updatedRide.PaxTypeCode,
                        paxType: updatedRide.PaxType,
                        dutyReportingTime: updatedRide.DutyReportingTime,
                        deBriefingTime: updatedRide.DeBriefingTime,
                        crewAddressChange: updatedRide.CrewAddressChange,
                        flightTimeChange: updatedRide.FlightTimeChange,
                        dutyReportTimeChange: updatedRide.DutyReportTimeChange,
                        debriefingTimeChange: updatedRide.DebriefingTimeChange,
                        rideTypeId: updatedRide.RideTypeId,
                        pickupTimeChange: updatedRide.PickupTimeChange,
                        rideType: updatedRide.RideType,
                        startTime: updatedRide.StartTime,
                        endTime: updatedRide.EndTime,
                        fmVehicleId: updatedRide.FmVehicleId,
                    }
                }]);
            } else {
                // Partial field update
                const changes = {};
                if (tripData.PickupDateTime != undefined && tripData.PickupDateTime !== '0001-01-01T00:00:00') changes.pickupDateTime = tripData.PickupDateTime;
                if (tripData.FlightDateTime != undefined && tripData.FlightDateTime !== '0001-01-01T00:00:00') changes.flightTime = formatTime(tripData.FlightDateTime, "hh:mm");
                if (tripData.ReportingTime != undefined && tripData.ReportingTime !== '0001-01-01T00:00:00') changes.dutyReportingTime = tripData.ReportingTime;
                if (tripData.DebriefingTime != undefined && tripData.DebriefingTime !== '0001-01-01T00:00:00') changes.deBriefingTime = tripData.DebriefingTime;
                if (tripData.FlightActualTime != undefined && tripData.FlightActualTime !== '0001-01-01T00:00:00') changes.flightTime = formatTime(tripData.FlightActualTime, "hh:mm");
                if (tripData.PickupAddress != null && tripData.PickupAddress !== '') changes.puStreet = tripData.PickupAddress;
                if (tripData.DropoffAddress != null && tripData.DropoffAddress !== '') changes.doStreet = tripData.DropoffAddress;
                if (Object.keys(changes).length > 0) {
                    this._rideStore.push([{ type: 'update', key: tripData.RideId, data: changes }]);
                }
            }

            // Only setState for the badge indicator — does NOT trigger DispatchGrid re-render (not a grid prop)
            this.setState({ socketDataUpdated: true });
            if (this._socketUpdateTimer) clearTimeout(this._socketUpdateTimer);
            this._socketUpdateTimer = setTimeout(() => {
                this.setState({ socketDataUpdated: false });
            }, 3000);
        } catch (e) {
            console.log("Error in " + this.displayName + "._applySocketUpdate function", e);
        }
    }

    removeCompletedRide = (rideId) => {
        if (this._rideStore) {
            this._rideStore.push([{ type: 'remove', key: rideId }]);
        }
    };

    // Returns false for auto-cancelled rides whose cancelledDate is older than 24 hours; true for everything else.
    _isAutoCancelWithinWindow = (ride) => {
        if (parseInt(ride.tripStatusId) !== parseInt(TripStatus.AUTOCANCELLED)) return true;
        if (!ride.cancelledDate) return false;
        return new Date(ride.cancelledDate) >= new Date(Date.now() - 24 * 60 * 60 * 1000);
    };

    rowClick(e) {
        //e.component.collapseAll(-1);
        if (e.component.isRowExpanded(e.key) === false) {
            e.component.expandRow(e.key);
        }
        else {
            e.component.collapseRow(e.key);
        }
    }

    //onContentReady(e) {
    //    if (!e.component.getSelectedRowKeys().length) { e.component.selectRowsByIndexes(0); }
    //}

    onExporting(e) {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');

        exportDataGrid({
            component: e.component,
            worksheet,
            autoFilterEnabled: true,
            customizeCell: ({ gridCell, excelCell }) => {
                if (gridCell.rowType === 'data') {
                    //if (gridCell.column.caption.replace(" ", "").toUpperCase() === 'CREWNAME') {
                    //    excelCell.value = gridCell.data.paxName;                        
                    //}

                    if (gridCell.column.caption.replace(" ", "").toUpperCase() === 'PICK-UP') {
                        excelCell.value = gridCell.data.puStreet;
                    }
                    if (gridCell.column.caption.replace(" ", "").toUpperCase() === 'DROPOFF') {
                        excelCell.value = gridCell.data.doStreet;
                    }
                    if (gridCell.column.caption.replace(" ", "").toUpperCase() === 'FLIGHTTERMINAL') {
                        excelCell.value = gridCell.data.flightTerminal + " " + gridCell.data.flightGate;
                    }
                    if (gridCell.column.caption.replace(" ", "").toUpperCase() === 'RIDESTATUS') {
                        excelCell.value = gridCell.data.preAssignedAcknowledgeStatus === "Assigned" ? "Assigned" : gridCell.data.tripStatusDesc;
                    }
                    if (gridCell.column.caption.replace(" ", "").toUpperCase() === 'REPORTING/DEBRIEFINGTIME') {
                        var colValue = "";
                        if (gridCell.data.dutyReportingTime !== null) {
                            if (gridCell.data.dutyReportTimeChange === true) {
                                colValue = gridCell.data.dutyReportingTime;
                            }
                        }
                        else if (gridCell.data.deBriefingTime !== null) {
                            if (gridCell.data.debriefingTimeChange === true) {
                                colValue = gridCell.data.deBriefingTime;
                            }
                        }
                        excelCell.value = colValue;
                    }
                }
            }
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DispatchRide.xlsx');
            });
        });
        e.cancel = true;
    }

    vehicleItemRender = (item) => {
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                <i className="fas fa-car" style={{ color: '#1a73e8', fontSize: '0.78rem', flexShrink: 0 }}></i>
                <span>{item.name}</span>
            </div>
        );
    }

    driverItemRender = (item) => {
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                <i className="fas fa-user" style={{ color: '#16a34a', fontSize: '0.78rem', flexShrink: 0 }}></i>
                <span>{item.name}</span>
            </div>
        );
    }

    workingHourItemRender = (item) => {
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                <i className="fas fa-clock" style={{ color: '#d97706', fontSize: '0.78rem', flexShrink: 0 }}></i>
                <span>{item.name} hr{item.name > 1 ? 's' : ''}</span>
            </div>
        );
    }

    workingHourFieldRender = (data) => {
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '7px', paddingLeft: '8px', height: '100%' }}>
                <i className="fas fa-clock" style={{ color: data ? '#d97706' : '#adb5bd', fontSize: '0.78rem', flexShrink: 0 }}></i>
                <input
                    className="dx-texteditor-input"
                    defaultValue={data ? `${data.name} hr${data.name > 1 ? 's' : ''}` : ''}
                    placeholder="Select working hour"
                    style={{ border: 'none', background: 'transparent', flex: 1, padding: 0, color: data ? '' : '#adb5bd' }}
                    readOnly
                />
            </div>
        );
    }

    toolbarItemRender() {
        // Single flex-wrap row: selects + all buttons together, so at any window width the
        // items that don't fit wrap onto a new line on their own (no Bootstrap breakpoints
        // needed) instead of overlapping. Each SelectBox's own width is halved (was 100% of
        // its wrapper) per request, independent of the wrapper's flex-basis below.
        return (
            <div className="d-flex flex-wrap align-items-start" style={{ gap: 8, rowGap: 8 }}>
                <div style={{ flex: '0 1 270px', minWidth: 180 }}>
                    <SelectBox
                        dataSource={this.state.serviceDrivers?.length > 0 ? this.state.serviceDrivers : []}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select driver"
                        name="dispatchDriverId"
                        defaultValue={0}
                        value={this.state.dispatchDriverId}
                        displayExpr='name'
                        valueExpr='id'
                        onSelectionChanged={this.handleDispatchDriverChange}
                        showClearButton={true}
                        disabled={false}
                        searchEnabled={true}
                        searchExpr="name"
                        searchMode="contains"
                        wrapItemText={true}
                        dropDownOptions={{ minWidth: 280 }}
                        itemRender={this.driverItemRender}
                    />
                    {this.state.errors["dispatchDriverId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["dispatchDriverId"]}</span>}
                </div>
                <div style={{ flex: '0 1 200px', minWidth: 140 }}>
                    <SelectBox
                        dataSource={this.state.serviceVehicles?.length > 0 ? this.state.serviceVehicles : []}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select vehicle"
                        name="dispatchVehicleId"
                        defaultValue={0}
                        value={this.state.dispatchVehicleId}
                        displayExpr='name'
                        valueExpr='id'
                        onSelectionChanged={this.handleDispatchVehicleChange}
                        showClearButton={true}
                        disabled={false}
                        searchEnabled={true}
                        searchExpr="name"
                        searchMode="contains"
                        itemRender={this.vehicleItemRender}
                    />
                    {this.state.errors["dispatchVehicleId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["dispatchVehicleId"]}</span>}
                </div>
                {
                    allowToAddDriverWorkingHours === "true" &&
                    <div style={{ flex: '0 1 200px', minWidth: 140 }}>
                        <SelectBox
                            dataSource={this.state.driverWorkingHours.length > 0 ? this.state.driverWorkingHours : []}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Select working hour"
                            name="driverWorkingHoursId"
                            defaultValue={0}
                            value={this.state.driverWorkingHoursId}
                            displayExpr='name'
                            valueExpr='id'
                            onSelectionChanged={this.handleDriverWorkingHourChange}
                            showClearButton={true}
                            disabled={false}
                            searchEnabled={true}
                            itemRender={this.workingHourItemRender}
                            fieldRender={this.workingHourFieldRender}
                        //visible={allowToAddDriverWorkingHours === "true" ? true : false}
                        />
                    </div>
                }
                <button type="button" id="btnSaveAssign" className="btn btn-success btn-sm" title="Assign Ride" onClick={this.handleMultipleJobAssign}>
                    {this.state.isVehicleMultipleAssignedSubmited && <span><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                    {!this.state.isVehicleMultipleAssignedSubmited && <span><i className="fas fa-check"></i> Assign</span>}
                </button>
                <button type="button" id="btnSaveAssign" className="btn btn-danger btn-sm" title="Unassign Ride" onClick={this.handleMultipleJobUnAssign}>
                    {this.state.isVehicleMultipleUnAssignedSubmited && <span><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                    {!this.state.isVehicleMultipleUnAssignedSubmited && <span><i className="fas fa-history"></i> Unassign</span>}
                </button>
                {
                    (session_mappedAccountId1 !== session_accountId
                        && session_mappedAccountId2 !== session_accountId
                        && session_mappedAccountId4 !== session_accountId
                        && session_mappedAccountId5 !== session_accountId
                        && session_mappedAccountId6 !== session_accountId
                        && session_mappedAccountId7 !== session_accountId) ? null :
                        <button type="button" id="btnAttendByTransporter" className="btn btn-warning btn-sm" title="Confirm Ride" onClick={this.handleMultipleJobAttend}>
                            {this.state.isRideMultipleAttendSubmited && <span><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                            {!this.state.isRideMultipleAttendSubmited && <span><i className="fas fa-check"></i> Confirm Ride</span>}
                        </button>
                }
                <button type="button" id="btnClubReservations" className="btn btn-primary btn-sm" title="Club Reservation(s)" disabled={this.state.selectedRowKeys.length < 2} onClick={this.handleClubReservations}>
                    <i className="fas fa-link"></i> Club Reservation(s)
                </button>
                <button type="button" id="btnUnclubReservations" className="btn btn-secondary btn-sm" title="Unclub Reservation" disabled={this.state.selectedRowKeys.length < 1} onClick={this.handleUnclubReservations}>
                    {this.state.isUnclubReservationsSubmitted && <span><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                    {!this.state.isUnclubReservationsSubmitted && <span><i className="fas fa-unlink"></i> Unclub Reservation</span>}
                </button>
                {this.state.socketDataUpdated && (
                    <span className="socket-data-updated-badge">
                        <i className="fas fa-sync-alt"></i> Trip(s) Data Updated...
                    </span>
                )}
            </div>
        );
    }
    onToolbarPreparing = async (e) => {
        try {
            let isButtonDisable = !this.state.isGridHasRow;
            e.toolbarOptions.items.unshift({
                location: 'after',
                widget: 'dxButton',
                showText: 'always',
                options: {
                    disabled: isButtonDisable,
                    //text: 'Export to Excel',
                    icon: 'export-excel-button',//'export',
                    elementAttr: {
                        "class": "dx-datagrid-export-button"
                    },
                    onClick: function () {
                        e.component.option("export.fileName", "DispatchRide");
                        e.component.exportToExcel(false);
                    },
                    hint: 'Export to Excel'
                }
            }, {
                location: 'after',
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    //onClick: this.handleOnRefreshGrid.bind(this),
                    onClick: this.handleSearch.bind(this),
                    hint: 'Refresh'
                }
            }
            )
            // Custom grid only: Pickup Time / Crew Type filters on the left of the grid's own toolbar.
            if (isCustomDispatchGrid()) {
                e.toolbarOptions.items.unshift({
                    location: 'before',
                    template: 'dispatchFilterItems',
                });
            }
        } catch (e) {
            console.log(e);
        }
    }
    onToolbarPreparingAlertNotification = async (e) => {
        try {
            e.toolbarOptions.items.unshift({
                location: 'before',
                template: 'multipleNotifications'
            }, {
                location: 'after',
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    //onClick: this.handleOnRefreshGrid.bind(this),
                    //onClick: await this.getAlertNotifications(false),
                    hint: 'Refresh'
                }
            });
        } catch (e) {
            console.log(e);
        }
    }
    toolbarAlertNotificationItemRender() {
        const isAll = this.state.isShowAlertNotificationsAll;
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <label
                    className={`notif-toggle-chip${isAll ? ' active' : ''}`}
                    htmlFor="isShowAlertNotificationsAll"
                    title="Toggle to show all notifications including already read ones"
                >
                    <input
                        type="checkbox"
                        id="isShowAlertNotificationsAll"
                        name="isShowAlertNotificationsAll"
                        checked={isAll}
                        onChange={this.handleAlertNotificationInputChange}
                        style={{ display: 'none' }}
                    />
                    <i className={isAll ? 'fas fa-eye' : 'fas fa-eye-slash'}></i>
                    {isAll ? ' All Notifications' : ' Unread Only'}
                </label>
                {this.state.alertNotificationsSource && this.state.alertNotificationsSource.length > 0 &&
                    <span className="notif-count-pill">
                        <i className="fas fa-bell"></i> {this.state.alertNotificationsSource.length} notification{this.state.alertNotificationsSource.length !== 1 ? 's' : ''}
                    </span>
                }
            </div>
        );
    }
    handleOnRefreshGrid = async (e) => {
        try {
            this.setState({ loadPanelVisible: true });
            e.component.option('icon', 'fas fa-spinner fa-spin');
            e.component.option('hint', 'In-process');
            clearInterval(this.dispatchInterval);
            clearInterval(this.dispatchIntervalHandle);
            clearInterval(this.countdownInterval);
            await this.handleSearch();
            if (!this.state.allowSocketConnection) {
                this.startAutoRefresh();
            }
        } catch (ex) {
            console.log(ex);
        }
        e.component.option('icon', 'refresh');
        e.component.option('hint', 'Refresh');
        this.setState({ loadPanelVisible: false });
    }

    enterKeyActionChanged(e) {
    }

    async refreshDispatch(e, data) {
        e.preventDefault();
        clearInterval(this.dispatchInterval);
        clearInterval(this.dispatchIntervalHandle);
        clearInterval(this.countdownInterval);
        await this.handleSearch();
        if (!this.state.allowSocketConnection) {
            this.startAutoRefresh();
        }
    }

    //async getPreApprovedRideList() {
    getPreApprovedRideList = async (e) => {
        try {
            let statusIds;
            if (this.state.isShowAll) {
                statusIds = this.state.statusList.map(s => parseInt(s.id));
            } else {
                const defaultExcluded = new Set([
                    parseInt(TripStatus.COMPLETED),
                    parseInt(TripStatus.CANCELLED),
                    parseInt(TripStatus.NOSHOWNONBILLABLE),
                    parseInt(TripStatus.NOSHOW),
                ]);
                if (this.state.isShowCompleted) defaultExcluded.add(parseInt(TripStatus.AUTOCANCELLED));
                statusIds = this.state.statusList
                    .filter(s => !defaultExcluded.has(parseInt(s.id)))
                    .map(s => parseInt(s.id));

                if (this.state.isShowCompleted === true) {
                    statusIds.push(parseInt(TripStatus.COMPLETED), parseInt(TripStatus.NOSHOW));
                }
                if (this.state.isShowCancelled === true) {
                    statusIds.push(parseInt(TripStatus.CANCELLED));
                }
            }

            var dispatchReservationRequest = new Object();
            dispatchReservationRequest.fromDate = this.state.searchFromDate; //formatFromDate(this.state.searchFromDate, "MM/dd/yyyy");
            dispatchReservationRequest.toDate = this.state.searchToDate; //formatFromDate(this.state.searchToDate, "MM/dd/yyyy");
            dispatchReservationRequest.vehicleTypeGroupId = "";
            dispatchReservationRequest.StatusId = statusIds.join(',');
            const requestParams = getRequestParams('POST', dispatchReservationRequest);
            await this.bindGrid(requestParams);
            //await this.bindGPSCalendar(requestParams);
        } catch (e) {
            console.log(e);
        }
    }

    async getPreApprovedGpsRideList() {
        try {
            const defaultExcluded = new Set([
                parseInt(TripStatus.COMPLETED),
                parseInt(TripStatus.CANCELLED),
                //parseInt(TripStatus.AUTOCANCELLED),
                parseInt(TripStatus.NOSHOWNONBILLABLE),
                parseInt(TripStatus.NOSHOW),
            ]);

            var dispatchReservationRequest = new Object();
            dispatchReservationRequest.fromDate = this.state.searchFromDate; //formatFromDate(this.state.searchFromDate, "MM/dd/yyyy");
            dispatchReservationRequest.toDate = this.state.searchToGpsDate; //formatFromDate(this.state.searchToGpsDate, "MM/dd/yyyy");
            dispatchReservationRequest.vehicleTypeGroupId = "";
            dispatchReservationRequest.StatusId = this.state.statusList
                .filter(s => !defaultExcluded.has(parseInt(s.id)))
                .map(s => s.id)
                .join(',');
            const requestParams = getRequestParams('POST', dispatchReservationRequest);
            //await this.bindGPSCalendar(requestParams);
        } catch (e) {
            console.log(e);
        }
    }

    async getMapUrl() {
        try {
            const cached = readCache('session_mapurl');
            if (cached) {
                this.setState({ trackmapUrl: cached });
                return;
            }
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('helper/map-url', requestParams);
            const data = await response.json();
            const trackmapUrl = data.resultMessage + "?accountId=" + parseInt(sessionStorage.getItem('session_accountId')) + "&locationId=" + parseInt(sessionStorage.getItem('session_locationId')) + "&userId=0&vgTypeId=0&rideId=0";
            writeCache('session_mapurl', trackmapUrl);
            this.setState({ trackmapUrl });
        } catch (e) {
            console.log(e);
        }
    }

    searchToggle = () => {
        var x = document.getElementById("advanceSearch");
        if (x.style.display === "none") {
            x.style.display = "block";
            this.setState({ isDateDisabled: true });
        } else {
            this.setState({ isDateDisabled: false });
            x.style.display = "none";
        }
    }
    sortByKeyAsc(array, key) {
        return array.sort(function (a, b) {
            var x = a[key]; var y = b[key];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
    }

    onDragStart(e) {
        e.itemData = this.state[e.fromData][e.fromIndex];
    }

    handleDragStart = (e, name) => {
        e.dataTransfer.setData("id", name);
    }

    handleDragOver = (e) => {
        e.preventDefault();
    }

    handleOnDrop = (e, item) => {
        let id = e.dataTransfer.getData("id");
        Swal.fire({
            title: "<small>Are you sure</small>",
            html: item.vehicleId > 0 ? "Do you want to Assign vehicle [" + item.displayName + "] to selected ride?" : "Do you want to Unassign vehicle to selected ride?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Continue',
            allowOutsideClick: false
        }).then((result) => {
            if (result.isConfirmed) {
                let assigntask = new Object();
                assigntask.rideDetails = new Object();
                let list = this.state.calRideVehicleList.filter((task) => {
                    if (task.rideId == id) {
                        assigntask = task;
                        task.status = item.status;
                        task.vehicleId = item.vehicleId;
                        task.driverId = task.driverId;
                        task.driverName = task.driverName;
                        task.displayName = item.displayName;
                        task.vehicleNo = item.status == "pending" ? "" : item.displayName;
                        task.jobId = item.status == "pending" ? 0 : item.jobId;
                        task.isVehicleAssigned = item.vehicleId > 0 ? true : false;
                    }
                    return task;
                });
                this.handleJobAssignUnAssign(assigntask);
            }
        })
    }

    handleOnDriverDrop = (e, item) => {
        let id = e.dataTransfer.getData("id");
        Swal.fire({
            title: "<small>Are you sure</small>",
            html: item.driverId > 0 ? "Do you want to Assign driver [" + item.driverName + "] to selected ride?" : "Do you want to Unassign driver to selected ride?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Continue',
            allowOutsideClick: false
        }).then((result) => {
            if (result.isConfirmed) {
                let assigntask = new Object();
                assigntask.rideDetails = new Object();
                let list = this.state.calRideDriverList.filter((task) => {
                    if (task.rideId == id) {
                        assigntask = task;
                        task.status = item.status;
                        task.vehicleId = task.vehicleId;
                        task.driverId = item.driverId;
                        task.driverName = item.driverName;
                        task.displayName = item.driverName;
                        task.vehicleNo = task.vehicleNo;
                        task.jobId = task.jobId;
                        task.isDriverAssigned = item.driverId > 0 ? true : false;
                    }
                    return task;
                });
                this.handleJobAssignUnAssign(assigntask);
            }
        })
    }

    handleMultipleJobAssignValidation() {
        let errors = this.state.errors;
        let formIsValid = true;
        errors.dispatchVehicleId = "";
        errors.dispatchDriverId = "";
        if (this.state.dispatchVehicleId == 0 && this.state.dispatchDriverId == 0) {
            formIsValid = false;
            errors.dispatchVehicleId = "Please select vehicle/driver.";
        }

        if (parseInt(this.state.driverWorkingHoursValue) > 0) {
            if (this.state.dispatchDriverId == 0) {
                formIsValid = false;
                errors.dispatchDriverId = "Please select driver.";
            }
        }

        //if (this.state.dispatchDriverId == 0) {
        //    formIsValid = false;
        //    errors.dispatchDriverId = "Please select driver.";
        //}
        this.setState({ errors: errors });
        return formIsValid;
    }

    async handleMultipleRideSelectionChanged(e) {
        // Completed / No Show rides can't be selected (their checkbox is also disabled in handleCustomCellPrepared).
        const completedRows = e.selectedRowsData.filter(this.isCompletedTrip);
        if (completedRows.length > 0) {
            const completedKeys = new Set(completedRows.map(r => r.rideId));
            const previousKeys = new Set(this.state.selectedRowKeys);
            const newlyChecked = completedRows.filter(r => !previousKeys.has(r.rideId));
            if (newlyChecked.length > 0) {
                this.showTripStatusWarning("Ride Selection", newlyChecked, "can't be selected because they are No Show or Completed.");
            }
            // onSelectionChanged fires again with the allowed keys.
            e.component.option('selectedRowKeys', e.selectedRowKeys.filter(key => !completedKeys.has(key)));
            return;
        }

        if (isCustomDispatchGrid() && this.enforceCustomSelectionRules(e)) {
            // The grid's selection was corrected; onSelectionChanged fires again with the allowed keys.
            return;
        }

        // The toolbar's Club / Unclub buttons are enabled from selectedRowKeys alone. It is a DispatchGrid prop,
        // so the memoized grid (which renders the toolbar) re-renders when it changes.
        this.setState({
            selectedRowKeys: e.selectedRowKeys,
        });
    }

    // Custom grid selection rules, same order as SgDispatchComponent.handleSelectionChanged:
    // 1. at most MAX_SELECTED_RIDES rows (checked first, so its warning takes precedence);
    // 2. every selected row must share the ride type (rideTypeId) of the rows already selected.
    // Rows already selected are kept and the newly checked ones that break a rule are dropped.
    // Returns true if the grid's selection had to be corrected.
    enforceCustomSelectionRules(e) {
        const previousKeys = new Set(this.state.selectedRowKeys);
        const rowByKey = new Map(e.selectedRowsData.map(r => [r.rideId, r]));
        let allowedKeys = [
            ...e.selectedRowKeys.filter(key => previousKeys.has(key)),
            ...e.selectedRowKeys.filter(key => !previousKeys.has(key)),
        ];

        let isLimitReached = false;
        if (allowedKeys.length > MAX_SELECTED_RIDES) {
            allowedKeys = allowedKeys.slice(0, MAX_SELECTED_RIDES);
            isLimitReached = true;
            Swal.fire({
                icon: 'warning',
                title: 'Selection limit reached',
                text: `You can select a maximum of ${MAX_SELECTED_RIDES} ${MAX_SELECTED_RIDES === 1 ? 'ride' : 'rides'} at a time. Please unselect a ride before selecting another one.`,
            });
        }

        const anchorRide = rowByKey.get(allowedKeys[0]);
        let rejectedRide = null;
        if (anchorRide) {
            allowedKeys = allowedKeys.filter(key => {
                const ride = rowByKey.get(key);
                const isSameRideType = !ride || ride.rideTypeId === anchorRide.rideTypeId;
                if (!isSameRideType && !rejectedRide) {
                    rejectedRide = ride;
                }
                return isSameRideType;
            });
        }
        // Swal shows one popup at a time, so skip this warning if the limit warning was already shown.
        if (rejectedRide && !isLimitReached) {
            const escape = value => String(value || '-').replace(/[&<>"']/g, c => `&#${c.charCodeAt(0)};`);
            Swal.fire({
                icon: 'warning',
                title: 'Different ride type',
                html: `Ride <b>${escape(rejectedRide.rideId)}</b> is a <b>${escape(rejectedRide.rideType)}</b> ride, `
                    + `but your current selection is for <b>${escape(anchorRide.rideType)}</b> rides.<br/><br/>`
                    + 'You can only select rides of the same ride type at a time. Clear the current selection to pick rides of a different ride type.',
            });
        }

        if (allowedKeys.length !== e.selectedRowKeys.length) {
            e.component.option('selectedRowKeys', allowedKeys);
            return true;
        }
        return false;
    }

    //handleEditingStart(e) {
    //    if (parseInt(e.data.tripStatusId) === parseInt(TripStatus.COMPLETED)) {
    //        e.cancel = true;
    //    }
    //    else {
    //        e.cancel = true;
    //    }
    //}

    handleCellPrepared(e) {
    }

    handleMultipleJobAttend = async (e) => {
        e.preventDefault();
        let isResult = false;
        let jobrides = [];
        const selectedRowsData = await this.dataGrid.instance.getDataByKeys(this.state.selectedRowKeys);

        if (selectedRowsData.length <= 0) {
            const isValid = await Swal.fire({
                title: selectedRowsData.length > 1 ? "<small>Confirm Ride</small>" : "<small>Confirm Ride</small>",
                text: "Please select atleast one ride.",
                icon: "info",
                dangerMode: false,
                width: "25%",
                dangerMode: false,
                allowOutsideClick: false
            });
            return;
        }

        const isConfirm = await this.askMultipleRideAttend(true);
        if (!isConfirm) {
            return;
        }

        this.setState({ isRideMultipleAttendSubmited: true });
        for (let i = 0; i < selectedRowsData.length; i++) {
            jobrides.push(selectedRowsData[i].rideId);
        }

        var attendRideRequest = new Object();
        attendRideRequest.Rides = jobrides;
        attendRideRequest.IsAttendRide = true;

        const requestParams = getRequestParams('POST', attendRideRequest);
        const response = await fetch('/dispatch-api/attend-job', requestParams);
        const data = await response.json();

        await Swal.fire({
            icon: data.isSuccess ? 'success' : 'error',
            title: data.isSuccess ? 'Confirmed Ride' : 'Oops...',
            text: data.resultMessage,
        }).then(async (result) => {
            /* Read more about isConfirmed, isDenied below */
            if (data.isSuccess) {
                this.setState({
                    isRideMultipleAttendSubmited: false, selectedRowKeys: [],
                });
                await this.updateMultipleRows(jobrides);
            } else {
                this.setState({ isRideMultipleAttendSubmited: false })
            }
        });
    }

    handleMultipleJobAssign = async (e) => {
        e.preventDefault();
        let isResult = false;
        let jobrides = [];
        const selectedRowsData = await this.dataGrid.instance.getDataByKeys(this.state.selectedRowKeys);

        if (selectedRowsData.length <= 0) {
            const isValid = await Swal.fire({
                title: selectedRowsData.length > 1 ? "<small>Multiple Ride Assignment</small>" : "<small>Ride Assignment</small>",
                text: "Please select atleast one ride.",
                icon: "info",
                dangerMode: false,
                width: "25%",
                dangerMode: false,
                allowOutsideClick: false
            });
            return;
        }

        // Only pending rides can be assigned.
        const nonPendingRows = selectedRowsData.filter(r => !this.isPendingTrip(r));
        if (nonPendingRows.length > 0) {
            await this.showTripStatusWarning("Ride Assignment", nonPendingRows, "can't be assigned because they are not pending. Please deselect them and try again.");
            return;
        }

        const isConfirm = await this.askMultipleVehicleAssignment(true);
        if (!isConfirm) {
            return;
        }

        if (this.handleMultipleJobAssignValidation()) {

            // Other still-pending rides in the same club(s) that the dispatcher didn't select — offer to assign them too.
            const siblingRows = (await this.getUnselectedClubSiblings(selectedRowsData, this.state.selectedRowKeys))
                .filter(this.isPendingTrip);
            if (siblingRows.length > 0) {
                const escape = this.escapeHtml;
                const siblingPreview = siblingRows.map(r => escape(r.rideId) + ' (Clubbed No ' + escape(r.clubbedNo) + ')').join(', ');
                // Confirm = include them, Cancel button = only the selected rows, X = abort.
                const siblingResult = await Swal.fire({
                    icon: 'question',
                    title: 'Other rides in the same club',
                    html: 'These Ride Id(s) are <b>not selected</b> but belong to the same club as your selection:<br/><b>' + siblingPreview + '</b>'
                        + '<br/><br/>Do you want to assign them to the same vehicle/driver as well?',
                    showCancelButton: true,
                    showCloseButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#6c757d',
                    confirmButtonText: 'Yes, include them',
                    cancelButtonText: 'No, only selected',
                    allowOutsideClick: false
                });
                if (siblingResult.isConfirmed) {
                    selectedRowsData.push(...siblingRows);
                } else if (siblingResult.dismiss !== Swal.DismissReason.cancel) {
                    return; // closed with X / Esc
                }
            }

            this.setState({ isVehicleMultipleAssignedSubmited: true });
            for (let i = 0; i < selectedRowsData.length; i++) {
                //switch (parseInt(selectedRowsData[i].tripStatusId)) {
                //    case parseInt(TripStatus.PENDING):
                //    case parseInt(TripStatus.DRIVERREJECTED):
                //    case parseInt(TripStatus.VEHICLEUNASSIGNED):
                //        jobrides.push(selectedRowsData[i].rideId);
                //        break;
                //}
                jobrides.push(selectedRowsData[i].rideId);
            }

            let clubbingReservations = selectedRowsData.filter(e => e.allowClubbing === true);
            if (clubbingReservations.length > 0 && clubbingReservations.length !== selectedRowsData.length) {
                await Swal.fire({
                    icon: 'question',
                    title: 'Clubbing Reservations',
                    html: 'Clubbing not allowed for these reservations. <br> Do you want to continue ..... ?',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Continue',
                    allowOutsideClick: false
                }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    this.setState({ isVehicleMultipleAssignedSubmited: false })
                    if (result.isConfirmed) {
                        isResult = true;
                    }
                });
            }
            else {
                isResult = true;
            }

            if (isResult) {
                if (this.state.dispatchVehicleNo != "") {
                    const data = await this.assignJob(jobrides, this.state.dispatchVehicleId, this.state.dispatchDriverId, parseInt(this.state.driverWorkingHoursValue));

                    await Swal.fire({
                        icon: data.isSuccess ? 'success' : 'error',
                        title: data.isSuccess ? 'Job Assigned' : 'Oops...',
                        text: data.resultMessage,
                    }).then(async (result) => {
                        /* Read more about isConfirmed, isDenied below */
                        if (data.isSuccess) {
                            this.setState({
                                isVehicleMultipleAssignedSubmited: false, selectedRowKeys: [], dispatchVehicleId: 0, dispatchDriverId: 0,
                                driverWorkingHoursId: 0,
                                driverWorkingHoursValue: "0",
                            });
                            await this.updateMultipleRows(jobrides);
                        } else {
                            this.setState({ isVehicleMultipleAssignedSubmited: false })
                        }
                    });
                }
            }
        }
    }

    // Assigns the given rides to a vehicle/driver via the same API as the toolbar's Assign button.
    // Also used by the Club Reservations popup's "Club & Assign". Returns the API response data.
    assignJob = async (rideIds, vehicleId, driverId, driverWorkingHours = 0) => {
        const request = {
            Rides: rideIds,
            VehicleId: vehicleId,
            DriverId: driverId,
            IsAssignRide: true,
            DriverWorkingHours: driverWorkingHours,
        };
        const requestParams = getRequestParams('POST', request);
        const response = await fetch('/dispatch-api/assign-job', requestParams);
        return response.json();
    }

    handleClubReservations = async (e) => {
        e.preventDefault();
        // Read the grid's live selection directly, rather than this.state.selectedRowKeys
        // (only as fresh as the last onSelectionChanged event) so a stale mirror can never
        // pull in rows the dispatcher didn't actually check.
        const selectedRowKeys = this.dataGrid.instance.getSelectedRowKeys();
        const allSelectedRowsData = await this.dataGrid.instance.getDataByKeys(selectedRowKeys);

        // Only pending rides can be clubbed; the rest are left out of the popup.
        const selectedRowsData = allSelectedRowsData.filter(this.isPendingTrip);
        const nonPendingRows = allSelectedRowsData.filter(r => !this.isPendingTrip(r));
        if (nonPendingRows.length > 0 && selectedRowsData.length >= 2) {
            const warnResult = await this.showTripStatusWarning("Club Reservations", nonPendingRows, "are not pending and will be left out. Do you want to continue with the pending reservation(s)?", true);
            if (!warnResult.isConfirmed) {
                return;
            }
        }

        if (selectedRowsData.length < 2) {
            await Swal.fire({
                title: "<small>Club Reservations</small>",
                text: nonPendingRows.length > 0
                    ? "Please select at least two pending reservations to club."
                    : "Please select at least two reservations to club.",
                icon: "info",
                width: "25%",
                allowOutsideClick: false
            });
            return;
        }

        // Rides whose allowClubbing flag is off can't be clubbed at all (grid shows them as "No").
        const notAllowed = selectedRowsData.filter(r => r.allowClubbing !== true);
        if (notAllowed.length > 0) {
            const rideIds = notAllowed.map(r => r.rideId).join(', ');
            await Swal.fire({
                title: "<small>Club Reservations</small>",
                html: "Clubbing is not allowed for the following Ride Id(s): <b>" + rideIds + "</b>. Please deselect them and try again.",
                icon: "warning",
                width: "35%",
                allowOutsideClick: false
            });
            return;
        }

        const alreadyClubbed = selectedRowsData.filter(r => r.isClubbed === true);
        if (alreadyClubbed.length > 0) {
            const rideIds = alreadyClubbed.map(r => r.rideId).join(', ');
            await Swal.fire({
                title: "<small>Club Reservations</small>",
                html: "The following Ride Id(s) are already clubbed: <b>" + rideIds + "</b>. Please deselect them and try again.",
                icon: "warning",
                width: "35%",
                allowOutsideClick: false
            });
            return;
        }

        this.refs.clubReservationsModal.showModal(selectedRowsData, async (rideIds) => {
            this.setState({ selectedRowKeys: [] });
            await this.updateMultipleRows(rideIds);
        });
    }

    pendingTripStatusIds = [parseInt(TripStatus.PENDING), parseInt(TripStatus.VEHICLEUNASSIGNED), parseInt(TripStatus.DRIVERREJECTED)];

    // No Show / No Show Non-Billable / Completed: can't be selected in the grid or unassigned.
    completedTripStatusIds = [parseInt(TripStatus.NOSHOW), parseInt(TripStatus.NOSHOWNONBILLABLE), parseInt(TripStatus.COMPLETED)];

    isCompletedTrip = r => !!r && this.completedTripStatusIds.includes(parseInt(r.tripStatusId));

    isPendingTrip = r => this.pendingTripStatusIds.includes(parseInt(r.tripStatusId));

    // Warns about rides whose trip status doesn't allow an action, listing each Ride Id with its status.
    // With allowContinue, shows Continue/Cancel and the caller checks the result's isConfirmed.
    showTripStatusWarning = (title, rows, message, allowContinue = false) => {
        const escape = this.escapeHtml;
        const ridesPreview = rows.map(r => escape(r.rideId) + ' (' + escape(r.tripStatusDesc) + ')').join(', ');
        return Swal.fire({
            title: "<small>" + title + "</small>",
            html: 'The following Ride Id(s): <b>' + ridesPreview + '</b> ' + message,
            icon: "warning",
            width: "35%",
            showCancelButton: allowContinue,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: allowContinue ? 'Continue' : 'OK',
            allowOutsideClick: false
        });
    }

    // A ride is clubbed only when it has a Clubbed No.
    hasClubbedNo = r => r.clubbedNo != null && String(r.clubbedNo).trim() !== '';

    escapeHtml = value => String(value == null ? '-' : value).replace(/[&<>"']/g, c => `&#${c.charCodeAt(0)};`);

    // Returns rides that share a Clubbed No with any of the given rows but aren't in selectedRowKeys.
    // Reads from the store rather than the grid, so rides hidden by the toolbar/search filters are found too.
    getUnselectedClubSiblings = async (rows, selectedRowKeys) => {
        const clubbedNos = new Set(rows.filter(this.hasClubbedNo).map(r => String(r.clubbedNo).trim()));
        if (clubbedNos.size === 0) {
            return [];
        }
        const selectedKeys = new Set(selectedRowKeys);
        const allRides = this._rideStore ? await this._rideStore.load() : [];
        return allRides.filter(r => !selectedKeys.has(r.rideId) && this.hasClubbedNo(r) && clubbedNos.has(String(r.clubbedNo).trim()));
    }

    handleUnclubReservations = async (e) => {
        e.preventDefault();
        // Read the grid's live selection directly (see handleClubReservations for why).
        const selectedRowKeys = this.dataGrid.instance.getSelectedRowKeys();
        const rowsData = await this.dataGrid.instance.getDataByKeys(selectedRowKeys);
        // getDataByKeys doesn't guarantee order; put rows back in the order they were checked,
        // so "first selected row" below really is the first one the dispatcher checked.
        const rowByKey = new Map(rowsData.map(r => [r.rideId, r]));
        const selectedRowsData = selectedRowKeys.map(key => rowByKey.get(key)).filter(Boolean);

        const hasClubbedNo = this.hasClubbedNo;
        const escape = this.escapeHtml;

        const firstRow = selectedRowsData[0];
        if (!firstRow || !hasClubbedNo(firstRow)) {
            await Swal.fire({
                title: "<small>Unclub Reservation</small>",
                html: firstRow
                    ? 'Ride Id <b>' + escape(firstRow.rideId) + '</b> is not clubbed (it has no Clubbed No). Please select a clubbed reservation to unclub.'
                    : 'Please select a clubbed reservation to unclub.',
                icon: "info",
                width: "30%",
                allowOutsideClick: false
            });
            return;
        }

        // Only pending rides can be unclubbed.
        const nonPendingRows = selectedRowsData.filter(r => !this.isPendingTrip(r));
        if (nonPendingRows.length > 0) {
            await this.showTripStatusWarning("Unclub Reservation", nonPendingRows, "can't be unclubbed because they are not pending. Please deselect them and try again.");
            return;
        }

        // Only rides with a Clubbed No go to the API; any others in the selection are skipped and listed below.
        const clubbedRows = selectedRowsData.filter(hasClubbedNo);
        const skippedRows = selectedRowsData.filter(r => !hasClubbedNo(r));

        const siblingRows = await this.getUnselectedClubSiblings(clubbedRows, selectedRowKeys);
        if (siblingRows.length > 0) {
            const siblingPreview = siblingRows.map(r => escape(r.rideId) + ' (Clubbed No ' + escape(r.clubbedNo) + ')').join(', ');
            // Confirm = include them, Cancel button = only the selected rows, X = abort.
            const siblingResult = await Swal.fire({
                icon: 'question',
                title: 'Other rides in the same club',
                html: 'These Ride Id(s) are <b>not selected</b> but belong to the same club as your selection:<br/><b>' + siblingPreview + '</b>'
                    + '<br/><br/>Do you want to unclub them as well?',
                showCancelButton: true,
                showCloseButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#6c757d',
                confirmButtonText: 'Yes, include them',
                cancelButtonText: 'No, only selected',
                allowOutsideClick: false
            });
            if (siblingResult.isConfirmed) {
                // The included rides must be pending too, same as the selected ones.
                const nonPendingSiblings = siblingRows.filter(r => !this.isPendingTrip(r));
                if (nonPendingSiblings.length > 0) {
                    await this.showTripStatusWarning("Unclub Reservation", nonPendingSiblings, "can't be unclubbed because they are not pending.");
                    return;
                }
                clubbedRows.push(...siblingRows);
            } else if (siblingResult.dismiss !== Swal.DismissReason.cancel) {
                return; // closed with X / Esc
            }
        }

        const rideIdsPreview = clubbedRows.map(r => escape(r.rideId) + ' (Clubbed No ' + escape(r.clubbedNo) + ')').join(', ');
        const skippedPreview = skippedRows.length > 0
            ? '<br/><br/><small>Skipped (no Clubbed No): <b>' + skippedRows.map(r => escape(r.rideId)).join(', ') + '</b></small>'
            : '';
        const confirmResult = await Swal.fire({
            icon: 'question',
            title: 'Unclub Reservation',
            html: 'Unclub the following Ride Id(s): <b>' + rideIdsPreview + '</b>?' + skippedPreview,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Unclub',
            allowOutsideClick: false
        });
        if (!confirmResult.isConfirmed) {
            return;
        }

        this.setState({ isUnclubReservationsSubmitted: true });

        const request = {
            RideIds: clubbedRows.map(r => r.rideId),
            DeviceTime: new Date().toISOString(),
        };

        try {
            const requestParams = getRequestParams('POST', request);
            const response = await fetch('/dispatch-api/guard-unclub-rides', requestParams);
            const data = await response.json();

            if (data.isSuccess) {
                const failedRides = (data.rides || []).filter(r => !r.isUnclubbed);
                if (failedRides.length > 0) {
                    const failedText = failedRides.map(r => r.rideId + (r.statusMessage ? ' (' + r.statusMessage + ')' : '')).join(', ');
                    await Swal.fire({
                        icon: 'warning',
                        title: 'Some Ride(s) could not be unclubbed',
                        html: failedText,
                    });
                } else {
                    await Swal.fire({
                        icon: 'success',
                        title: 'Unclubbed',
                        text: data.resultMessage || 'Selected reservation(s) have been unclubbed.',
                    });
                }
                this.setState({ selectedRowKeys: [] });
                await this.updateMultipleRows(clubbedRows.map(r => r.rideId));
            } else {
                await Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: data.resultMessage,
                });
            }
        } catch (err) {
            await Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong while unclubbing the selected reservation(s).',
            });
        } finally {
            this.setState({ isUnclubReservationsSubmitted: false });
        }
    }

    handleMultipleJobUnAssign = async (e) => {
        e.preventDefault();
        let jobRides = [];
        let preUnAssignRides = [];
        let jobIds = [];
        const selectedRowsData = await this.dataGrid.instance.getDataByKeys(this.state.selectedRowKeys);

        if (selectedRowsData.length <= 0) {
            const isValid = await Swal.fire({
                title: selectedRowsData.length > 1 ? "<small>Multiple Ride Unassignment</small>" : "<small>Ride Unassignment</small>",
                text: "Please select atleast one assigned ride.",
                icon: "info",
                dangerMode: false,
                width: "25%",
                dangerMode: false,
                allowOutsideClick: false
            });
            return;
        }

        // No Show / No Show Non-Billable / Completed rides can't be unassigned at all.
        const lockedRows = selectedRowsData.filter(this.isCompletedTrip);
        if (lockedRows.length > 0) {
            await this.showTripStatusWarning("Ride Unassignment", lockedRows, "can't be unassigned because they are No Show or Completed. Please deselect them and try again.");
            return;
        }

        // Other non-pending rides can be unassigned, but warn the dispatcher first.
        const nonPendingRows = selectedRowsData.filter(r => !this.isPendingTrip(r));
        if (nonPendingRows.length > 0) {
            const warnResult = await this.showTripStatusWarning("Ride Unassignment", nonPendingRows, "are not pending. Do you want to continue unassigning them?", true);
            if (!warnResult.isConfirmed) {
                return;
            }
        }

        const isConfirm = await this.askMultipleVehicleAssignment(false);
        if (!isConfirm) {
            return;
        }

        this.setState({ isVehicleMultipleUnAssignedSubmited: true });
        var selectedObj = "";
        for (let i = 0; i < selectedRowsData.length; i++) {
            //selectedObj = selectedObj + selectedRowsData[i].rideId + ",";                
            switch (parseInt(selectedRowsData[i].tripStatusId)) {
                case parseInt(TripStatus.PENDING):
                case parseInt(TripStatus.DRIVERREJECTED):
                case parseInt(TripStatus.VEHICLEUNASSIGNED):
                    preUnAssignRides.push(selectedRowsData[i].rideId);
                    break;
                case parseInt(TripStatus.ONLOCATION):
                case parseInt(TripStatus.VEHICLEASSIGNED):
                case parseInt(TripStatus.DRIVERACCEPTED):
                    jobRides.push(selectedRowsData[i].rideId);
                    //if (selectedRowsData[i].jobId <= 0) {
                    //    jobRides.push(selectedRowsData[i].rideId);
                    //}
                    //else {
                    //    jobIds.push(selectedRowsData[i].jobId);
                    //    jobRides.push(selectedRowsData[i].rideId);
                    //}
                    break;
            }
        }

        //if (jobIds.length > 0)
        {

            //let jobId = jobIds[k];
            var unassignJobRequest = new Object();
            unassignJobRequest.DispatcherId = 0;
            unassignJobRequest.JobRides = jobRides;
            unassignJobRequest.PreUnAssignRides = preUnAssignRides;
            unassignJobRequest.DriverWorkingHours = 0;
            const requestParams = getRequestParams('POST', unassignJobRequest);
            //const jobresponse = await fetch('/dispatch-api/' + jobId + '/unassign-job/', requestParams);
            const jobresponse = await fetch('/dispatch-api/unassign-jobtrip/', requestParams);
            const jobdata = await jobresponse.json();

            //for (let k = 0; k < jobRides.length; k++) {
            //    let jobId = jobIds[k];
            //    var unassignJobRequest = new Object();
            //    unassignJobRequest.DispatcherId = 0;
            //    unassignJobRequest.JobRides = jobRides;
            //    unassignJobRequest.PreUnAssignRides = preUnAssignRides;
            //    const requestParams = getRequestParams('POST', unassignJobRequest);
            //    //const jobresponse = await fetch('/dispatch-api/' + jobId + '/unassign-job/', requestParams);
            //    const jobresponse = await fetch('/dispatch-api/unassign-jobtrip/', requestParams);
            //    const jobdata = await jobresponse.json();
            //}

            //if (jobdata.isSuccess)
            {
                await Swal.fire({
                    icon: jobdata.isSuccess ? 'success' : 'error',
                    title: jobdata.isSuccess ? 'Job Unassigned' : 'Oops...',
                    text: jobdata.isSuccess ? "Job unassigned successful" : "",
                }).then(async (result) => {
                    /* Read more about isConfirmed, isDenied below */
                    this.setState({
                        isVehicleMultipleUnAssignedSubmited: false, selectedRowKeys: [], dispatchVehicleId: 0,
                        dispatchDriverId: 0,
                    });
                    await this.updateMultipleRows([...jobRides, ...preUnAssignRides]);
                });
            }
        }
        //else if (jobrides.length > 0) {
        //    if (this.state.dispatchVehicleNo != "") {
        //        var preAssignUnAssignRideRequest = new Object();
        //        preAssignUnAssignRideRequest.Rides = jobrides;
        //        preAssignUnAssignRideRequest.VehicleId = this.state.dispatchVehicleId;
        //        preAssignUnAssignRideRequest.DriverId = this.state.dispatchDriverId;
        //        preAssignUnAssignRideRequest.IsAssignRide = false;

        //        const requestParams = getRequestParams('POST', preAssignUnAssignRideRequest);
        //        const response = await fetch('/dispatch-api/pre-assign-unassign-ride', requestParams);
        //        const data = await response.json();

        //        Swal.fire({
        //            icon: data.isSuccess ? 'success' : 'error',
        //            title: data.isSuccess ? 'Job Unassigned' : 'Oops...',
        //            text: data.resultMessage,
        //        }).then((result) => {
        //            /* Read more about isConfirmed, isDenied below */
        //            if (data.isSuccess) {
        //                this.setState({
        //                    isVehicleMultipleUnAssignedSubmited: false, selectedRowKeys: [], dispatchVehicleId: 0,
        //                    dispatchDriverId: 0,
        //                });
        //                //this.handleRefresh(false);
        //                this.getVehiclesList();
        //                this.getPreApprovedRideList();
        //                //this.getPreApprovedGpsRideList();
        //            } else {
        //                this.setState({ isVehicleMultipleUnAssignedSubmited: false })
        //            }
        //        });
        //    }
        //}
    }

    async askMultipleVehicleAssignment(blflag) {
        let isResult = false;
        await Swal.fire({
            title: "<small>Are you sure</small>",
            html: blflag === true ? "Do you want to Assign driver/vehicle to selected rides?" : "Do you want to Unassign driver/vehicle to selected rides?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Continue',
            allowOutsideClick: false
        }).then((result) => {
            if (result.isConfirmed) {
                isResult = true;
            }
        })
        return isResult;
    }

    async askMultipleRideAttend(blflag) {
        let isResult = false;
        await Swal.fire({
            title: "<small>Are you sure</small>",
            html: blflag === true ? "Do you want to Attend selected rides?" : "Do you want to Unattend selected rides?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Continue',
            allowOutsideClick: false
        }).then((result) => {
            if (result.isConfirmed) {
                isResult = true;
            }
        })
        return isResult;
    }

    handleDispatchVehicleChange(selectedOption) {
        let vehicleId = (selectedOption.selectedItem != null ? selectedOption.selectedItem.id : 0);
        let vehicleNo = (selectedOption.selectedItem != null ? selectedOption.selectedItem.name : "");
        this.setState({
            dispatchVehicleId: vehicleId,
            dispatchVehicleNo: vehicleNo,
        });
    }

    handleDispatchDriverChange = (selectedOption) => {
        this.setState({ dispatchDriverId: (selectedOption.selectedItem != null ? selectedOption.selectedItem.id : 0), })
    }

    handleDriverWorkingHourChange = (selectedOption) => {
        this.setState({
            driverWorkingHoursId: (selectedOption.selectedItem != null ? selectedOption.selectedItem.id : 0),
            driverWorkingHoursValue: (selectedOption.selectedItem != null ? selectedOption.selectedItem.name : "0"),
        });
    }

    async bindGPSCalendar(requestParams) {
        this.setState({
            loadPanelVisible: true,
            isSubmited: true
        })

        try {
            const response = await fetch('/dispatch-api/pre-approved-rides', requestParams);
            const data = await response.json();

            if (data.isSuccess) {
                let rideVehicles = [];
                let rideDrivers = [];

                for (let k = 0; k < data.dispatchReservations.length; k++) {
                    var rideObject = new Object();
                    rideObject.rideDetails = new Object();

                    var rideDriverObject = new Object();
                    rideDriverObject.rideDrivers = new Object();

                    if (data.dispatchReservations[k].vehicleId === 0) {
                        rideObject.rideId = data.dispatchReservations[k].rideId;
                        rideObject.text = data.dispatchReservations[k].paxName + " " + data.dispatchReservations[k].vehicleTypeName + " [" + formatTime(data.dispatchReservations[k].pickupDateTime, "hh:mm") + "] ";
                        rideObject.status = "pending";
                        rideObject.vehicleId = 0;
                        rideObject.vehicleNo = "";
                        rideObject.driverId = data.dispatchReservations[k].driverId;
                        rideObject.driverName = data.dispatchReservations[k].driverName;
                        rideObject.jobId = 0;
                        rideObject.pickupDateTime = new Date(data.dispatchReservations[k].pickupDateTime);
                        rideObject.displayName = "Job(s)";
                        rideObject.rideDetails = data.dispatchReservations[k];
                    }
                    else {
                        rideObject.rideId = data.dispatchReservations[k].rideId;
                        rideObject.text = data.dispatchReservations[k].paxName + " " + data.dispatchReservations[k].vehicleTypeName + " [" + formatTime(data.dispatchReservations[k].pickupDateTime, "hh:mm") + "] ";
                        rideObject.status = data.dispatchReservations[k].vehicleNo;
                        rideObject.displayName = data.dispatchReservations[k].vehicleNo;
                        rideObject.vehicleId = data.dispatchReservations[k].vehicleId;
                        rideObject.vehicleNo = data.dispatchReservations[k].vehicleNo;
                        rideObject.driverId = data.dispatchReservations[k].driverId;
                        rideObject.driverName = data.dispatchReservations[k].driverName;
                        rideObject.jobId = data.dispatchReservations[k].jobId;
                        rideObject.rideDetails = data.dispatchReservations[k];
                    }
                    rideVehicles.push(rideObject);

                    if (data.dispatchReservations[k].driverId === 0) {
                        rideDriverObject.rideId = data.dispatchReservations[k].rideId;
                        rideDriverObject.text = data.dispatchReservations[k].paxName + " " + data.dispatchReservations[k].vehicleTypeName + " [" + formatTime(data.dispatchReservations[k].pickupDateTime, "hh:mm") + "] ";
                        rideDriverObject.status = "pending";
                        rideDriverObject.vehicleId = data.dispatchReservations[k].vehicleId;
                        rideDriverObject.vehicleNo = data.dispatchReservations[k].vehicleNo;
                        rideDriverObject.driverId = 0;
                        rideDriverObject.driverName = "Job(s)";
                        rideDriverObject.jobId = 0;
                        rideDriverObject.pickupDateTime = new Date(data.dispatchReservations[k].pickupDateTime);
                        rideDriverObject.displayName = "Job(s)";
                        rideDriverObject.rideDetails = data.dispatchReservations[k];
                    }
                    else {
                        rideDriverObject.rideId = data.dispatchReservations[k].rideId;
                        rideDriverObject.text = data.dispatchReservations[k].paxName + " " + data.dispatchReservations[k].vehicleTypeName + " [" + formatTime(data.dispatchReservations[k].pickupDateTime, "hh:mm") + "] ";
                        rideDriverObject.status = data.dispatchReservations[k].driverId;
                        rideDriverObject.displayName = data.dispatchReservations[k].driverName;
                        rideDriverObject.vehicleId = data.dispatchReservations[k].vehicleId;
                        rideDriverObject.vehicleNo = data.dispatchReservations[k].vehicleNo;
                        rideDriverObject.driverId = data.dispatchReservations[k].driverId;
                        rideDriverObject.driverName = data.dispatchReservations[k].driverName;
                        rideDriverObject.jobId = data.dispatchReservations[k].jobId;
                        rideDriverObject.rideDetails = data.dispatchReservations[k];
                    }
                    rideDrivers.push(rideDriverObject);
                }

                var vehicleFilter = rideVehicles.filter(function (result) { return result.vehicleId == 0; });
                if (vehicleFilter.length == 0) {
                    var rideObject = new Object();
                    rideObject.text = "";
                    rideObject.rideId = "";
                    rideObject.status = "pending";
                    rideObject.vehicleId = 0;
                    rideObject.vehicleNo = "";
                    rideObject.driverId = 0;
                    rideObject.driverName = "";
                    rideObject.jobId = 0;
                    rideObject.pickupDateTime = null;
                    rideObject.displayName = "Job(s)";
                    rideObject.rideDetails = new Object();
                    rideVehicles.push(rideObject);
                }

                var driverFilter = rideDrivers.filter(function (result) { return result.driverId == 0; });
                if (driverFilter.length == 0) {
                    var rideObject = new Object();
                    rideObject.text = "";
                    rideObject.rideId = "";
                    rideObject.status = "pending";
                    rideObject.vehicleId = 0;
                    rideObject.vehicleNo = "";
                    rideObject.driverId = 0;
                    rideObject.driverName = "";
                    rideObject.jobId = 0;
                    rideObject.pickupDateTime = null;
                    rideObject.displayName = "Job(s)";
                    rideObject.rideDetails = new Object();
                    rideDrivers.push(rideObject);
                }

                for (let v = 0; v < this.state.calServiceVehicles.length; v++) {
                    var vehicle = this.state.calServiceVehicles[v];
                    var vehicleFilter = rideVehicles.filter(function (result) { return vehicle.id === result.vehicleId; });
                    var vehicleObject = new Object();

                    if (vehicleFilter.length == 0) {
                        vehicleObject.rideId = "";
                        vehicleObject.text = "";
                        vehicleObject.vehicleNo = vehicle.name;
                        vehicleObject.vehicleId = vehicle.id;
                        vehicleObject.driverName = "";
                        vehicleObject.driverId = 0;
                        vehicleObject.jobId = 0;
                        vehicleObject.status = vehicle.name;
                        vehicleObject.displayName = vehicle.name;
                        vehicleObject.rideDetails = new Object();
                        rideVehicles.push(vehicleObject);
                    }
                }

                for (let v = 0; v < this.state.calServiceDrivers.length; v++) {
                    var driver = this.state.calServiceDrivers[v];
                    var driverFilter = rideDrivers.filter(function (result) { return driver.id === result.driverId; });
                    var driverObject = new Object();
                    if (driverFilter.length == 0) {
                        driverObject.rideId = "";
                        driverObject.text = "";
                        driverObject.vehicleNo = "";
                        driverObject.vehicleId = 0;
                        driverObject.driverName = driver.fullName;
                        driverObject.driverId = driver.id;
                        driverObject.jobId = 0;
                        driverObject.status = driver.name;
                        driverObject.displayName = driver.name;
                        driverObject.rideDetails = new Object();
                        rideDrivers.push(driverObject);
                    }
                }

                this.setState({
                    calRideVehicleList: rideVehicles,
                    calRideDriverList: rideDrivers,
                    calVehicleList: this.sortByKeyAsc(rideVehicles, "vehicleId"),
                    calDriverList: this.sortByKeyAsc(rideDrivers, "driverId"),
                });

                let allVehicleType = [];
                let allDrivers = [];
                let vehicleTypeList = [];
                let driverNameList = [];

                this.state.calVehicleList.forEach(task => {
                    allVehicleType.push(task);
                });

                this.state.calDriverList.forEach(task => {
                    allDrivers.push(task);
                });

                const map = new Map();
                for (const item of allVehicleType) {
                    if (!map.has(item.vehicleId)) {
                        map.set(item.vehicleId, true);
                        vehicleTypeList.push({
                            status: item.status,
                            displayName: item.displayName,
                            vehicleId: item.vehicleId,
                            driverId: item.driverId,
                        });
                    }
                }

                const drivermap = new Map();
                for (const item of allDrivers) {
                    if (!drivermap.has(item.driverId)) {
                        drivermap.set(item.driverId, true);
                        driverNameList.push({
                            driverId: item.driverId,
                            driverName: item.driverName,
                            vehicleId: item.vehicleId,
                        });
                    }
                }
                this.setState({ calAvailableVehicles: vehicleTypeList, calAvailableDrivers: driverNameList })
            }
        } catch (e) {
        }

        this.setState({
            loadPanelVisible: false,
            isSubmited: false
        })
    }

    async getStatusList() {
        try {
            const cached = readCache('session_tripstatus');
            if (cached && cached.statusType) {
                await new Promise(resolve => this.setState({ statusList: cached.statusType }, resolve));
                return;
            }
            const requestParams = getRequestParams('GET', {});
            const response = await fetch('/status-api/' + StatusType.Booking, requestParams);
            const data = await response.json();
            writeCache('session_tripstatus', data);
            await new Promise(resolve => this.setState({ statusList: data.statusType }, resolve));
        } catch (e) {
            console.log(e);
        }
    }

    async getVehiclesList() {
        try {
            const cached = readCache('session_vehicles');
            if (cached && cached.vehiclesDropdown) {
                this.setState({
                    vehicleList: cached.vehiclesDropdown,
                    calServiceVehicles: cached.vehiclesDropdown,
                    serviceVehicles: cached.vehiclesDropdown,
                });
                return;
            }
            const requestParams = getRequestParams('GET', {});
            const response = await fetch('/vehicle-api/dropdown-customer-vehicles/0/0', requestParams);
            const data = await response.json();
            writeCache('session_vehicles', data);
            this.setState({
                vehicleList: data.vehiclesDropdown,
                calServiceVehicles: data.vehiclesDropdown,
                serviceVehicles: data.vehiclesDropdown,
            });
        } catch (e) {
            console.log(e);
        }
    }

    async getDriversList() {
        try {            
            const cached = readCache('session_drivers');
            if (cached && cached.driversDropdownList) {
                this.setState({
                    driverList: cached.driversDropdownList,
                    calServiceDrivers: cached.driversDropdownList,
                    serviceDrivers: cached.driversDropdownList,
                });
                return;
            }
            const requestParams = getRequestParams('GET', {});
            const response = await fetch('/driver-api/dropdown/', requestParams);
            const data = await response.json();
            writeCache('session_drivers', data);
            this.setState({
                driverList: data.driversDropdownList,
                calServiceDrivers: data.driversDropdownList,
                serviceDrivers: data.driversDropdownList,
            });
        } catch (e) {
            console.log(e);
        }
    }

    async getLocationList() {
        try {
            const cached = readCache('session_locations');
            if (cached && cached.locations) {
                this.setState({ locationList: cached.locations });
                return;
            }
            const requestParams = getRequestParams('GET', {});
            const response = await fetch('/account-api/locations', requestParams);
            const data = await response.json();
            writeCache('session_locations', data);
            this.setState({ locationList: data.locations });
        } catch (e) {
            console.log(e);
        }
    }

    async getVehicleGroupTypeList() {
        try {
            const cached = readCache('session_vehiclegrouptype');
            if (cached && cached.vehicleGroupTypes) {
                this.setState({ vehicleGroupTypesList: cached.vehicleGroupTypes });
                return;
            }
            const requestParams = getRequestParams('GET', {});
            const response = await fetch('/vehicle-group-type-api/vehicle-group-type', requestParams);
            const data = await response.json();
            if (data.isSuccess) {
                writeCache('session_vehiclegrouptype', data);
                this.setState({ vehicleGroupTypesList: data.vehicleGroupTypes });
            }
        } catch (e) {
            console.log(e);
        }
    }

    async getVehicleTypeList() {
        try {
            const cached = readCache('session_vehicletype');
            if (cached && cached.apiVehicleType) {
                this.setState({ vehicleTypeList: cached.apiVehicleType });
                return;
            }
            const requestParams = getRequestParams('POST', {});
            const response = await fetch('/vehicletype-api/vehicletype', requestParams);
            const data = await response.json();
            if (data.isSuccess) {
                writeCache('session_vehicletype', data);
                this.setState({ vehicleTypeList: data.apiVehicleType });
            }
        } catch (e) {
            console.log(e);
        }
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        const rideStatusFields = ['isShowPending', 'isShowInProcess', 'isShowCompleted', 'isShowCancelled', 'isShowPickupSchedules'];

        if (name === 'isShowAll' && value === true) {
            const cleared = {};
            rideStatusFields.forEach(f => { cleared[f] = false; });
            this.setState({ isShowAll: true, ...cleared });
        } else if (rideStatusFields.includes(name) && value === true && this.state.isShowAll) {
            this.setState({ [name]: value, isShowAll: false });
        } else {
            this.setState({ [name]: value });
        }
    }

    handleGridSearchChange = (e) => {
        const text = e.target.value;
        this.setState({ gridSearchText: text });
        if (this.dataGrid && this.dataGrid.instance) {
            this.dataGrid.instance.option('searchPanel.text', text);
        }
    };

    handleGridSearchPaste = (e) => {
        const pasted = (e.clipboardData || window.clipboardData).getData('text');
        if (!pasted) return;
        const el = e.target;
        const start = typeof el.selectionStart === 'number' ? el.selectionStart : el.value.length;
        const end = typeof el.selectionEnd === 'number' ? el.selectionEnd : el.value.length;
        const current = this.state.gridSearchText || '';
        const newValue = current.slice(0, start) + pasted + current.slice(end);
        e.preventDefault();
        this.setState({ gridSearchText: newValue });
        if (this.dataGrid && this.dataGrid.instance) {
            this.dataGrid.instance.option('searchPanel.text', newValue);
        }
    };

    handleGridSearchClear = () => {
        if (this.dataGrid && this.dataGrid.instance) {
            this.dataGrid.instance.option('searchPanel.text', '');
        }
        this.setState({
            gridSearchText: '',
            totalRideCount: this.state.originalRideCount,
            isGridHasRow: this.state.originalRideCount > 0,
        });
    };

    handleOptionChange = (e) => {
        if (e.name === 'searchPanel') {
            // Search cleared manually inside the grid — restore original count immediately
            if (e.value === '') {
                this.setState({
                    gridSearchText: '',
                    totalRideCount: this.state.originalRideCount,
                    isGridHasRow: this.state.originalRideCount > 0,
                });
                return;
            }
            // Search text changed — read filtered count after DevExtreme finishes filtering
            setTimeout(() => {
                if (this.dataGrid && this.dataGrid.instance) {
                    const count = this.dataGrid.instance.totalCount();
                    if (count !== this.state.totalRideCount) {
                        this.setState({ totalRideCount: count, isGridHasRow: count > 0 });
                    }
                }
            }, 0);
        } else if (e.name === 'filterValue' || e.name === 'columns') {
            setTimeout(() => {
                if (this.dataGrid && this.dataGrid.instance) {
                    const count = this.dataGrid.instance.totalCount();
                    if (count !== this.state.totalRideCount) {
                        this.setState({ totalRideCount: count, isGridHasRow: count > 0 });
                    }
                }
            }, 0);
        }
    };

    handleAlertNotificationInputChange = async (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value,
        });

        await this.getAlertNotifications(value);
    }
    handleSearchFromDateChange(date) {
        //var dt = formatFromDate(date, "MM/dd/yyyy");
        //this.setState({
        //    searchFromDate: date,
        //    //currentGPSDate: date,
        //    //currentGPSDisplayDate: formatFromDate(date, "MMM/dd/yyyy"),
        //});
        let fromDateValue = formatFromDate(date.value, "MM/dd/yyyy hh:mm");
        this.setState({ searchFromDate: fromDateValue })
    }
    handleSearchToDateChange(date) {
        //var dt = formatFromDate(date, "MM/dd/yyyy");
        //this.setState({ searchToDate: date });
        let toDateValue = formatFromDate(date.value, "MM/dd/yyyy hh:mm");
        this.setState({ searchToDate: toDateValue })
    }
    handleVehicleGroupTypeChange(e) {
        this.setState({
            filterVehicleGroupTypeList: e.selectedRowKeys.length && e.selectedRowKeys || []
        });
    }
    syncDataGridVehicleGroupSelection(e) {
        this.setState({
            filterVehicleGroupTypeList: e.value || []
        });
    }
    handleVehicleTypeChange(e) {
        this.setState({
            filterVehicleTypeList: e.selectedRowKeys.length && e.selectedRowKeys || []
        });
    }
    syncDataGridVehicleTypeSelection(e) {
        this.setState({
            filterVehicleTypeList: e.value || []
        });
    }
    //handleStatusChange(e) {
    //    this.setState({
    //        filterStatusList: e.selectedRowKeys.length && e.selectedRowKeys || []
    //    });
    //}
    //syncDataGridStatusSelection(e) {
    //    this.setState({
    //        filterStatusList: e.value || []
    //    });
    //}
    handleLocationChange(selectedOption) {
        this.setState({ locationId: (selectedOption.selectedItem != null ? selectedOption.selectedItem.locationId : 0), })
    }
    handleVehicleChange(e) {
        this.setState({
            filterVehicleList: e.selectedRowKeys.length && e.selectedRowKeys || []
        });
    }
    syncDataGridVehicleSelection(e) {
        this.setState({
            filterVehicleList: e.value || []
        });
    }
    handleDriverChange(selectedOption) {
        this.setState({ driverId: (selectedOption.selectedItem != null ? selectedOption.selectedItem.id : 0), })
    }
    handleRowPrepared(e) {
        if (e.rowType === 'data') {
            if (e.data.isClubbed === true) {
                e.rowElement.classList.add("bgClubbedForSg");
            }
            else if (e.data.pickupUrgentAlert === true && (e.data.tripStatusId === (parseInt(TripStatus.PENDING)))) {
                e.rowElement.classList.add("bgPickupUrgentAlert");
            }
            else if (e.data.pickupAlert === true && (e.data.tripStatusId === (parseInt(TripStatus.PENDING)))) {
                e.rowElement.classList.add("bgPickupAlert");
            }
            else if (e.data.displayDayDifference === true && (e.data.tripStatusId === (parseInt(TripStatus.PENDING)))) {
                e.rowElement.classList.add("bgurgent");
            }
            else {
                switch (e.data.tripStatusId) {
                    case (parseInt(TripStatus.PENDING)):
                        e.rowElement.classList.add("bgpending");
                        break;
                    case (parseInt(TripStatus.VEHICLEASSIGNED)):
                        e.rowElement.classList.add("bgassigned");
                        break;
                    case (parseInt(TripStatus.DRIVERACCEPTED)):
                        e.rowElement.classList.add("bgdriveraccepted");
                        break;
                    case (parseInt(TripStatus.DRIVERREJECTED)):
                        e.rowElement.classList.add("bgdriverrejected");
                        break;
                    case (parseInt(TripStatus.ONLOCATION)):
                        e.rowElement.classList.add("bgonlocation");
                        break;
                    case (parseInt(TripStatus.PAXLOAD)):
                        e.rowElement.classList.add("bgboarded");
                        break;
                    case (parseInt(TripStatus.COMPLETED)):
                        e.rowElement.classList.add("bgcompleted");
                        break;
                    case (parseInt(TripStatus.CANCELLED)):
                    case (parseInt(TripStatus.AUTOCANCELLED)):
                        e.rowElement.classList.add("bgcancelled");
                        break;
                    default:
                        e.rowElement.classList.add("bgpending");
                        break;
                }
            }
        }
    }
    handleCustomRowPrepared(e) {
        if (e.rowType === 'data') {
            if (e.data.isClubbed === true) {
                e.rowElement.classList.add("bgClubbedForSg");
                return;
            }
            // if (e.data.pickupUrgentAlert === true && (e.data.tripStatusId === (parseInt(TripStatus.PENDING)))) {
            //     e.rowElement.classList.add("bgPickupUrgentAlert");
            // }
            // else if (e.data.pickupAlert === true && (e.data.tripStatusId === (parseInt(TripStatus.PENDING)))) {
            //     e.rowElement.classList.add("bgPickupAlert");
            // }
            // else if (e.data.displayDayDifference === true && (e.data.tripStatusId === (parseInt(TripStatus.PENDING)))) {
            //     e.rowElement.classList.add("bgurgent");
            // }
            //if (e.data.assignedStatus === "Delay Assigned" && (e.data.tripStatusId === (parseInt(TripStatus.PENDING)))) {
            if (e.data.assignedStatusId === 2 && (e.data.tripStatusId === (parseInt(TripStatus.PENDING)))) {
                e.rowElement.classList.add("bgurgent");
            }
            else
                 {
                switch (e.data.tripStatusId) {
                    //case (parseInt(TripStatus.PENDING)):
                    //    e.rowElement.classList.add("bgpending");
                    //    break;
                    case (parseInt(TripStatus.VEHICLEASSIGNED)):
                    case (parseInt(TripStatus.DRIVERACCEPTED)):
                    case (parseInt(TripStatus.ONLOCATION)):
                    case (parseInt(TripStatus.PAXLOAD)):
                        e.rowElement.classList.add("bgInProcess");
                        break;
                    case (parseInt(TripStatus.COMPLETED)):
                        e.rowElement.classList.add("bgboarded");
                        break;
                    // case (parseInt(TripStatus.DRIVERACCEPTED)):
                    //     e.rowElement.classList.add("bgboarded");
                    //     break;
                    //case (parseInt(TripStatus.DRIVERREJECTED)):
                    //  e.rowElement.classList.add("bgdriverrejected");
                    //  break;
                    //case (parseInt(TripStatus.ONLOCATION)):
                    //  e.rowElement.classList.add("bgonlocation");
                    //  break;
                    //case (parseInt(TripStatus.PAXLOAD)):
                    //  e.rowElement.classList.add("bgboarded");
                    //  break;
                    //case (parseInt(TripStatus.COMPLETED)):
                    //  e.rowElement.classList.add("bgcompleted");
                    //  break;
                    case (parseInt(TripStatus.CANCELLED)):
                    case (parseInt(TripStatus.AUTOCANCELLED)):
                        e.rowElement.classList.add("bgcancelled");
                        break;
                    default:
                        e.rowElement.classList.add("bgpending");
                        break;
                }
            }
        }
    }
    openViewReservationModel(e, data) {
        e.preventDefault();
        this.refs.viewReservationModal.showModal("Reservation", data);
    }
    openReservationHistoryModel(e, data) {
        e.preventDefault();
        this.refs.reservationHistoryModal.showModal("Reservation", data.rideId);
    }
    async updateVehicleEtdEta(e, data) {
        e.preventDefault();
        try {
            const requestParams = getRequestParams('GET', "");
            const response = await fetch('/dispatch-api/update-eta-etd/' + data.rideId + '/' + data.tripStatusId, requestParams);
            const dataResult = await response.json();

            await this.getPreApprovedRideList();
        } catch (e) {
            console.log(e);
        }
    }
    async handleJobAssignUnAssign(assigntask) {
        try {
            let jobrides = [];
            if (assigntask.vehicleNo != "" || assigntask.driverId > 0) {
                jobrides.push(assigntask.rideDetails.rideId);
                var preAssignUnAssignRideRequest = new Object();
                preAssignUnAssignRideRequest.Rides = jobrides;
                preAssignUnAssignRideRequest.VehicleId = assigntask.vehicleId;
                preAssignUnAssignRideRequest.DriverId = assigntask.driverId;
                preAssignUnAssignRideRequest.IsAssignRide = true;

                const requestParams = getRequestParams('POST', preAssignUnAssignRideRequest);
                const response = await fetch('/dispatch-api/pre-assign-unassign-ride', requestParams);
                const data = await response.json();

                let successmessage = "", title = "";
                if (assigntask.isVehicleAssigned === true) {
                    title = "Vehicle Assignment";
                    successmessage = "Vehicle assigned successfully."
                }
                else if (assigntask.isVehicleAssigned === false) {
                    title = "Vehicle Unassignment";
                    successmessage = "Vehicle unassigned successfully."
                }
                else if (assigntask.isDriverAssigned === true) {
                    title = "Driver Assignment";
                    successmessage = "Driver assigned successfully."
                }
                else if (assigntask.isDriverAssigned === false) {
                    title = "Driver Unassignment";
                    successmessage = "Driver Unassigned successfully."
                }

                await Swal.fire({
                    icon: data.isSuccess ? 'success' : 'error',
                    title: data.isSuccess ? title : 'Oops...',
                    text: successmessage, //data.resultMessage,
                }).then(async (result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (data.isSuccess) {
                        if (result.isConfirmed) {
                            await this.getPreApprovedRideList();
                        }
                    }
                });
            }
            else {
                if (assigntask.rideDetails.isPreAssignedRide == true) {
                    jobrides.push(assigntask.rideDetails.rideId);
                    var preAssignUnAssignRideRequest = new Object();
                    preAssignUnAssignRideRequest.Rides = jobrides;
                    preAssignUnAssignRideRequest.VehicleId = assigntask.rideDetails.vehicleId;
                    preAssignUnAssignRideRequest.DriverId = assigntask.rideDetails.driverId;
                    preAssignUnAssignRideRequest.IsAssignRide = false;

                    const requestParams = getRequestParams('POST', preAssignUnAssignRideRequest);
                    const response = await fetch('/dispatch-api/pre-assign-unassign-ride', requestParams);
                    const data = await response.json();

                    Swal.fire({
                        icon: data.isSuccess ? 'success' : 'error',
                        title: data.isSuccess ? 'Job Unassigned' : 'Oops...',
                        text: data.resultMessage,
                    }).then(async (result) => {
                        /* Read more about isConfirmed, isDenied below */
                        if (data.isSuccess) {
                            if (result.isConfirmed) {
                                await this.getPreApprovedRideList();
                            }
                        }
                    });
                }
                else {
                    let jobId = assigntask.jobId;
                    var unassignJobRequest = new Object();
                    unassignJobRequest.DispatcherId = 0;
                    const requestParams = getRequestParams('POST', unassignJobRequest);
                    const response = await fetch('/dispatch-api/' + jobId + '/unassign-job/', requestParams);
                    const data = await response.json();

                    await Swal.fire({
                        icon: data.isSuccess ? 'success' : 'error',
                        title: data.isSuccess ? 'Job Unassigned' : 'Oops...',
                        text: data.resultMessage,
                    }).then(async (result) => {
                        /* Read more about isConfirmed, isDenied below */
                        if (data.isSuccess) {
                            if (result.isConfirmed) {
                                await this.getPreApprovedRideList();
                            }
                        }
                    });
                }
            }
        } catch (e) {

        }
    }
    async handleRefresh(isRefresh) {
        if (!isRefresh) {
            clearInterval(this.dispatchIntervalHandle);
            await this.handleSearch();
            this.dispatchIntervalHandle = setInterval(async () => {
                await this.handleSearch();
            }, dispatchRefreshInterval * 1000);
        } else {
            clearInterval(this.dispatchIntervalHandle);
            this.setState({ isSubmited: false });
            this.startAutoRefresh();
        }
    }
    prevDate(e) {
        let currentDate = new Date(new Date(this.state.currentGPSDate).setDate(this.state.currentGPSDate.getDate() - 1));
        this.setState({
            currentGPSDate: currentDate,
            currentGPSDisplayDate: formatFromDate(currentDate, "MMM/dd/yyyy"),
        });
        this.handleDaySearch(e);
    }
    nextDate(e) {
        let currentDate = new Date(new Date(this.state.currentGPSDate).setDate(this.state.currentGPSDate.getDate() + 1));
        this.setState({
            currentGPSDate: currentDate,
            currentGPSDisplayDate: formatFromDate(currentDate, "MMM/dd/yyyy"),
        });
        this.handleDaySearch(e);
    }

    async handleDispatchSearch(e) {
        try {
            await new Promise(resolve =>
                this.setState({ isSearch: true, isPageLoading: false, isSearchLoading: true }, resolve)
            );
            await this.handleSearch();
        } catch (e) {

        }
    }

    // Builds the dispatch search request from current filter state — shared by handleSearch and updateSingleRow
    _buildDispatchRequest = () => {
        const tripVehicleGroupType = this.state.filterVehicleGroupTypeList.join(',');
        const tripVehicleType = this.state.filterVehicleTypeList.join(',');
        const tripVehicle = this.state.filterVehicleList.join(',');

        const defaultExcluded = new Set([
            parseInt(TripStatus.COMPLETED),
            parseInt(TripStatus.CANCELLED),
            parseInt(TripStatus.NOSHOWNONBILLABLE),
            parseInt(TripStatus.NOSHOW),
        ]);
        const statusIds = [];

        if (this.state.isShowPending) {
            statusIds.push(parseInt(TripStatus.PENDING), parseInt(TripStatus.VEHICLEUNASSIGNED), parseInt(TripStatus.DRIVERREJECTED));
        }
        if (this.state.isShowInProcess) {
            statusIds.push(parseInt(TripStatus.VEHICLEASSIGNED), parseInt(TripStatus.DRIVERACCEPTED),
                parseInt(TripStatus.ONLOCATION), parseInt(TripStatus.PAXLOAD));
        }
        if (this.state.isShowCompleted) {
            statusIds.push(parseInt(TripStatus.COMPLETED), parseInt(TripStatus.NOSHOW));
        }
        if (this.state.isShowCancelled) {
            statusIds.push(parseInt(TripStatus.CANCELLED));
        }
        if (this.state.isShowAll) {
            this.state.statusList.forEach(s => statusIds.push(parseInt(s.id)));
        }
        if (!this.state.isSearch) {
            const autoRefreshExcluded = new Set(defaultExcluded);
            if (this.state.isShowCompleted) autoRefreshExcluded.add(parseInt(TripStatus.AUTOCANCELLED));
            this.state.statusList.forEach(s => {
                if (!autoRefreshExcluded.has(parseInt(s.id))) statusIds.push(parseInt(s.id));
            });
        }
        if (statusIds.length === 0) {
            this.state.statusList.forEach(s => {
                if (!defaultExcluded.has(parseInt(s.id))) statusIds.push(parseInt(s.id));
            });
        }

        // Auto-cancelled always visible in default view, excluded when Completed filter is active
        const autoCancelId = parseInt(TripStatus.AUTOCANCELLED);
        if (!this.state.isShowCompleted && !statusIds.includes(autoCancelId)) {
            statusIds.push(autoCancelId);
        }

        return {
            RideId: this.state.rideId == 0 ? 0 : parseInt(this.state.rideId),
            FromDate: this.state.searchFromDate,
            ToDate: this.state.searchToDate,
            VehicleTypeGroupId: tripVehicleGroupType,
            VehicleTypeId: tripVehicleType,
            VehicleId: tripVehicle,
            StatusId: statusIds.join(','),
            DriverId: this.state.driverId,
            IsLive: this.state.isLive,
            IsInHouse: this.state.isInHouse,
            IsFarmIn: this.state.isFarmIn,
            IsFarmOut: this.state.isFarmOut,
        };
    }

    // Targeted row update — calls API once, pushes only the affected row. Single-ride version.
    updateSingleRow = async (rideId) => {
        await this.updateMultipleRows([rideId]);
    }

    // Targeted multi-row update — calls API once, pushes all affected rows in a single store.push().
    // Each rideId is either updated (found in response) or removed (filtered out / completed).
    updateMultipleRows = async (rideIds) => {
        try {
            if (!this._rideStore || !rideIds || rideIds.length === 0) { await this.handleSearch(); return; }
            const requestParams = getRequestParams('POST', this._buildDispatchRequest());
            const response = await fetch('/dispatch-api/pre-approved-rides', requestParams);
            const data = await response.json();
            if (data.isSuccess && data.dispatchReservations) {
                const ops = rideIds.map(rideId => {
                    const updatedRide = data.dispatchReservations.find(r => r.rideId === rideId);
                    if (!updatedRide || !this._isAutoCancelWithinWindow(updatedRide)) {
                        return { type: 'remove', key: rideId };
                    }
                    return { type: 'update', key: rideId, data: updatedRide };
                });
                this._rideStore.push(ops);
            }
        } catch (e) {
            await this.handleSearch(); // fallback to full refresh on error
        }
    }

    async handleSearch(e) {
        //console.log("search method called");
        try {
            this.setState({
                seconds: dispatchRefreshInterval,
                isStopAutoRefresh: true
            });

            const dispatchReservationRequest = this._buildDispatchRequest();
            const requestParams = getRequestParams('POST', dispatchReservationRequest);
            await this.bindGrid(requestParams);

            this.setState({
                //loadPanelVisible: false,
                //isSubmited: false,
                searchFromDate: dispatchReservationRequest.FromDate,
                searchToDate: dispatchReservationRequest.ToDate,
                dateRange: "Date Range: " + dispatchReservationRequest.FromDate + " to " + dispatchReservationRequest.ToDate,
                //isStopAutoRefresh: true,
            });
            //await this.bindGPSCalendar(requestParams);
        } catch (e) {

        }
    }

    async bindGrid(requestParams) {
        this.setState({
            loadPanelVisible: true,
            isSubmited: true
        });

        let gridDataUpdate = {};

        try {
            //const searchParams = JSON.parse(requestParams);
            const response = await fetch('/dispatch-api/pre-approved-rides', requestParams);
            const data = await response.json();
            //console.log("data: " + JSON.stringify(data));

            data.dispatchReservations = data.dispatchReservations || [];

            if (this.state.isShowPickupSchedules) {
                data.dispatchReservations = data.dispatchReservations.filter(f => f.noOfAdults > 0);
            }

            // Auto-cancelled: only show if cancelled within the last 24 hours; pickup date filtered by API date range
            data.dispatchReservations = data.dispatchReservations.filter(r => this._isAutoCancelWithinWindow(r));

            // In-Process/Pending filters: never show Cancelled/AutoCancelled trips alongside these rides
            if (this.state.isShowInProcess || this.state.isShowPending) {
                data.dispatchReservations = data.dispatchReservations.filter(r =>
                    parseInt(r.tripStatusId) !== parseInt(TripStatus.CANCELLED) &&
                    parseInt(r.tripStatusId) !== parseInt(TripStatus.AUTOCANCELLED)
                );
            }

            //console.log(data);
            if (data.isSuccess) {
                this._initDataSource(data.dispatchReservations);
                const count = data.dispatchReservations ? data.dispatchReservations.length : 0;
                gridDataUpdate = {
                    reservationGridDataSource: this._rideDataSource,
                    isGridHasRow: count > 0,
                    totalRideCount: count,
                    originalRideCount: count,
                };
            }
        } catch (e) {
        }

        // Merge data + loading state into one setState so the grid never renders blank
        this.setState(prevState => ({
            ...gridDataUpdate,
            loadPanelVisible: false,
            isSubmited: false,
            isSearchLoading: false,
            isPageLoading: prevState.isPageLoading ? false : prevState.isPageLoading,
        }));

        //clearInterval(this.dispatchInterval);
        //clearInterval(this.dispatchIntervalHandle);
    }

    async getAlertNotifications(flag) {
        try {
            this.setState({ isAlertLoading: true });
            const requestParams = getRequestParams('GET', {});
            const response = await fetch('/notification-api/notification-list', requestParams);
            const data = await response.json();
            if (data.isSuccess) {
                this.setState({
                    alertNotificationsSource: data.alertNotifcations !== null ? data.alertNotifcations.filter(f => f.dataRead === flag) : [],
                    //alertNotificationsSource: data.alertNotifcations !== null ? data.alertNotifcations : [],
                });
            }
        } catch (e) {
            console.log(e);
        }
        this.setState({ isAlertLoading: false });
    }

    async handleDaySearch(e) {
        const tripVehicleGroupType = this.state.filterVehicleGroupTypeList.join(',');
        const tripVehicleType = this.state.filterVehicleTypeList.join(',');
        const tripVehicle = this.state.filterVehicleList.join(',');

        const statusIds = [];

        if (this.state.filterStatusList.length === 0) {
            const isCompleted = this.state.isShowCompleted;
            const isCancelled = this.state.isShowCancelled;
            this.state.statusList.forEach(s => {
                const id = parseInt(s.id);
                if (isCompleted) {
                    statusIds.push(id);
                } else if (!isCancelled) {
                    const excluded = new Set([
                        parseInt(TripStatus.COMPLETED), parseInt(TripStatus.CANCELLED),
                        parseInt(TripStatus.NOSHOWNONBILLABLE),
                    ]);
                    if (!excluded.has(id)) statusIds.push(id);
                } else {
                    if (id !== parseInt(TripStatus.COMPLETED) && id !== parseInt(TripStatus.NOSHOW)) statusIds.push(id);
                }
            });
        } else {
            this.state.filterStatusList.forEach(id => statusIds.push(id));
            if (this.state.isShowCompleted) {
                statusIds.push(parseInt(TripStatus.COMPLETED), parseInt(TripStatus.NOSHOW));
            }
            if (this.state.isShowCancelled) {
                statusIds.push(parseInt(TripStatus.CANCELLED));
            }
        }

        // Auto-cancelled always visible
        const autoCancelId = parseInt(TripStatus.AUTOCANCELLED);
        if (!statusIds.includes(autoCancelId)) statusIds.push(autoCancelId);

        var dispatchReservationRequest = new Object();
        dispatchReservationRequest.RideId = this.state.rideId == 0 ? 0 : parseInt(this.state.rideId);
        dispatchReservationRequest.FromDate = formatFromDate(this.state.currentGPSDate, "MM/dd/yyyy");
        dispatchReservationRequest.ToDate = formatFromDate(this.state.currentGPSDate, "MM/dd/yyyy");
        dispatchReservationRequest.VehicleTypeGroupId = tripVehicleGroupType;
        dispatchReservationRequest.VehicleTypeId = tripVehicleType;
        dispatchReservationRequest.VehicleId = tripVehicle;
        dispatchReservationRequest.StatusId = statusIds.join(',');
        dispatchReservationRequest.DriverId = this.state.driverId;
        dispatchReservationRequest.IsLive = this.state.isLive;
        dispatchReservationRequest.IsInHouse = this.state.isInHouse;
        dispatchReservationRequest.IsFarmIn = this.state.isFarmIn;
        dispatchReservationRequest.IsFarmOut = this.state.isFarmOut;
        const requestParamsGPS = getRequestParams('POST', dispatchReservationRequest);
        //await this.bindGPSCalendar(requestParamsGPS);
    }

    async handleClearSearch() {
        this.setState({
            rideId: "",
            driverId: 0,
            locationId: 0,
            filterVehicleList: [],
            filterVehicleGroupTypeList: [],
            filterVehicleTypeList: [],
            filterStatusList: [],
            searchFromDate: formatFromDate(this.state.searchFromDate, "MM/dd/yyyy hh:mm"),
            searchToDate: formatToDate(this.state.searchToDate, "MM/dd/yyyy hh:mm"),
        });
        //let myVar = setTimeout(() => this.getPreApprovedRideList(), 500)
    }

    async handleReset() {
        await new Promise(resolve => this.setState({
            isSubmited: false,
            isAdvancedSubmited: false,
            isPageLoading: true,
            reservationGridDataSource: null,
            alertNotification: null,
            isGridHasRow: false,
            totalRideCount: 0,
            originalRideCount: 0,
            loadPanelEnabled: true,
            loadPanelVisible: false,
            isLive: false,
            isInHouse: false,
            isFarmIn: false,
            isFarmOut: false,
            // Reset back to the default "All" status filter.
            isShowCompleted: false,
            isShowCancelled: false,
            isShowPending: false,
            isShowInProcess: false,
            isShowAll: true,
            searchFromDate: formatFromDate(startTime, "MM/dd/yyyy hh:mm"),
            searchToDate: formatToDate(endTime, "MM/dd/yyyy hh:mm"),
            searchToGpsDate: formatFromDate(new Date(new Date(currentTime).setDate(currentTime.getDate() + 0)), "MM/dd/yyyy hh:mm"),
            seconds: dispatchRefreshInterval,
            rideId: "",
            vehicleTypeId: 0,
            statusId: 0,
            locationId: 0,
            vehicleId: 0,
            driverId: 0,
            isStopAutoRefresh: false,
            //rowChanged: this.rowChanged,
            isRestartRefresh: false,
            refreshDataSource: null,
            currentGPSDate: currentTime,
            currentGPSDisplayDate: formatFromDate(currentTime, "MMM/dd/yyyy hh:mm"),
            dateRange: "Date Range: " + formatFromDate(startTime, "MM/dd/yyyy hh:mm") + " to " + formatToDate(endTime, "MM/dd/yyyy hh:mm"),
            dispatchVehicleId: 0,
            dispatchDriverId: 0,
            isVehicleMultipleAssignedSubmited: false,
            isVehicleMultipleUnAssignedSubmited: false,
            selectedRowKeys: [],
           
            selectedPickupTimeSlotId: null,
            selectedCrewTypeId: null,
            trackmapUrl: "",
            isExportToReport: false,
            driverWorkingHours: driverWorkingHoursobject,
            driverWorkingHoursId: 0,
            driverWorkingHoursValue: "0",
            isSearch: false,
            errors: {
                dispatchVehicleId: 0,
                dispatchDriverId: 0,
            }
        }, resolve));

        await this.getPreApprovedRideList();
    }

    editViewRide = (data) => {
        clearInterval(this.dispatchInterval);
        clearInterval(this.dispatchIntervalHandle);
        clearInterval(this.countdownInterval);
        //this.state.alertSoundNotification = null;

        this.props.history.push({
            pathname: '/crudride',
            state: { rideId: data.rideId, sourceUrl: "/dispatch/list" }
        });

        //navigate("/crudride", {
        //    state: { rideId: data.rideId, sourceUrl: "/dispatch/list", sourceState: this.state }
        //});

        //this.context.history.push({
        //    pathname: '/crudride',
        //    //state: { detail: data }
        //    state: { rideId: data.rideId, sourceUrl: "/dispatch/list", sourceState: this.state }
        //});

        //window.location.href = "/crudride";
    }

    async readNotification(e, notification) {
        e.preventDefault();
        this.setState({
            loadPanelVisible: true
        });

        try {
            var newObject = new Object();
            newObject.Id = parseInt(notification.id);
            newObject.AccountId = parseInt(notification.accountId);
            newObject.LocationId = parseInt(notification.locationId);
            newObject.AirlineCode = notification.airlineCode;
            newObject.FlightNumber = notification.flightNumber;
            newObject.AccountName = notification.accountName;
            newObject.EmployeeNumber = notification.employeeNumber;
            newObject.CrewName = notification.crewName;
            newObject.Rank = notification.rank;
            newObject.ChangeType = notification.changeType;
            newObject.PreviousData = notification.previousData;
            newObject.CurrentData = notification.currentData;
            newObject.ChangeSource = notification.changeSource;
            newObject.ChangeTime = notification.changeTime;
            newObject.DataRead = true;
            newObject.ReadAt = currentTime;
            newObject.ReadBy = notification.readBy;
            newObject.TransactionId = notification.transactionId;
            newObject.FlightTime = notification.flightTime;
            newObject.RideId = notification.rideId;

            const requestParams = getRequestParams('POST', newObject);
            let path = "notification-api/notification-update";
            const response = await fetch(path, requestParams);
            const data = await response.json();

            if (data.isSuccess) {
                await this.getAlertNotifications(false);
            }
        } catch (e) {
            console.log(e);
        }
        this.setState({
            loadPanelVisible: false
        });
    }

    renderDetail(props) {
        return (<div><DispatchDetailComponent
            useRef="dipatchDetailRef"
            isDispatchRowIndex={props.rowIndex}
            dispatchRideId={props.data.rideId}
            singleRideSource={props.data}
            refreshDataSource={this.handleSearch}
            updateSingleRow={this.updateSingleRow}
            stopAutoRefresh={this.dispatchInterval}
            stopAutoRefreshHandle={this.dispatchIntervalHandle}
            isStopAutoRefresh={this.isStopAutoRefresh}
            handleRefresh={this.handleRefresh}
            editViewRide={this.editViewRide}
            serviceVehicles={this.state.vehicleList || []}
            serviceDrivers={this.state.driverList || []}
            serviceStatusList={this.state.statusList || []}
        /></div>);
    }

    filterSearchFromDate = time => {
        const currentDate = currentTime;
        const selectedDate = new Date(time);
        return currentDate.getTime() < selectedDate.getTime();
    }

    filterSearchToDate = time => {
        const currentDate = currentTime;
        const selectedDate = new Date(time);
        return currentDate.getTime() < selectedDate.getTime();
    }

    renderGridCell = (data) => CellRenderers.renderEtaEtdCell(data, this.updateVehicleEtdEta);
    renderReatAtTimeCell = CellRenderers.renderReatAtTimeCell;
    renderReatNotificationCell = (data) => CellRenderers.renderReatNotificationCell(data, this.readNotification);
    renderChangeTypeCell = CellRenderers.renderChangeTypeCell;
    renderPickupTimeCell = CellRenderers.renderPickupTimeCell;
    renderDeBriefingCell = CellRenderers.renderDeBriefingCell;
    renderReportingDeBriefingCell = CellRenderers.renderReportingDeBriefingCell;

    showAddressPopup = (e, address, title) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ addressPopupVisible: true, addressPopupText: address, addressPopupTitle: title });
    }

    renderPickupAddressCell = (data) => CellRenderers.renderPickupAddressCell(data, this.showAddressPopup);
    renderDropoffAddressCell = (data) => CellRenderers.renderDropoffAddressCell(data, this.showAddressPopup);
    renderFlightInfoCell = CellRenderers.renderFlightInfoCell;
    renderJobIdCell = CellRenderers.renderJobIdCell;
    renderPaxNameCell = CellRenderers.renderPaxNameCell;

    render() {
        const { seconds } = this.state;

        const r_session_accountId = parseInt(sessionStorage.getItem("session_accountId"));
        const r_session_mappedAccountId1 = parseInt(sessionStorage.getItem("session_mappedAccountId1"));
        const r_session_mappedAccountId2 = parseInt(sessionStorage.getItem("session_mappedAccountId2"));
        const r_session_mappedAccountId4 = parseInt(sessionStorage.getItem("session_mappedAccountId4"));
        const r_session_mappedAccountId5 = parseInt(sessionStorage.getItem("session_mappedAccountId5"));
        const r_session_mappedAccountId6 = parseInt(sessionStorage.getItem("session_mappedAccountId6"));
        const r_session_mappedAccountId7 = parseInt(sessionStorage.getItem("session_mappedAccountId7"));

        const mappedAccountIdVariant = (
            r_session_mappedAccountId1 !== r_session_accountId
            && r_session_mappedAccountId2 !== r_session_accountId
            && r_session_mappedAccountId4 !== r_session_accountId
            && r_session_mappedAccountId5 !== r_session_accountId
            && r_session_mappedAccountId6 !== r_session_accountId
            && r_session_mappedAccountId7 !== r_session_accountId
        ) ? 'standard' : 'custom';
        //console.log('[Dispatch] session_accountId:', r_session_accountId, '| session_mappedAccountId7:', r_session_mappedAccountId7, '| match:', r_session_mappedAccountId7 === r_session_accountId, '| variant:', mappedAccountIdVariant);

        return (
            <div className="content-wrapper" id="dispatch-page">
                <LoadingPopupComponent
                    visible={this.state.isPageLoading}
                    title="Loading Dispatch"
                    subTitle="Fetching rides and data, please wait..."
                />
                <LoadingPopupComponent
                    visible={this.state.isSearchLoading}
                    title="Searching Rides"
                    subTitle="Applying filters, please wait..."
                    icon="fas fa-search fa-beat-fade"
                />
                <LoadingPopupComponent
                    visible={this.state.isAlertLoading}
                    title="Loading Notifications"
                    subTitle="Fetching alert & notifications..."
                    icon="fas fa-bell fa-beat-fade"
                />
                <div className="content-header">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 col-md-2 col-sm-12">
                                <h1 className="m-0 text-dark">Dispatch</h1>
                            </div>
                            <div className="col-lg-9 col-md-10 col-sm-12 text-right">
                                <ol className="breadcrumb float-sm-right">
                                    {
                                        this.state.allowSocketConnection === false ?
                                            <li id="refreshStatus" className="text-md">
                                                <span className="align-middle"><i className="fas fa-sync fa-spin"></i>&nbsp;<label className="m-0 text-dark">Refresh in <strong className="text-red">{seconds}</strong> second(s)</label>&nbsp;&nbsp;</span>
                                            </li> : null
                                    }
                                    {
                                        (this.state.allowSearchReservation === true) &&
                                        (
                                            <li>
                                                <a className="nav-link btn btn-outline-secondary btn-sm" data-widget="control-sidebar" data-slide="true" href="#" role="button" title="Advanced Search"><i className="fas fa-th-large"></i></a>
                                            </li>
                                        )}
                                    {
                                        (this.state.allowNewReservation === true) &&
                                        (
                                            <NavItem><NavLink tag={Link} to="/reservations" className="btn btn-block btn-outline-secondary btn-sm" title="New Reservation"><i className="fas fa-plus"></i> New Reservation</NavLink></NavItem>
                                        )}
                                    <li className="nav-item">
                                        <div className="btn-group">
                                            <button type="button" className="btn btn-outline-secondary btn-sm"><i className="fas fa-list"></i> More Action</button>
                                            <button type="button" className="btn btn-outline-secondary btn-sm dropdown-toggle dropdown-icon" data-toggle="dropdown">
                                                <span className="sr-only">Toggle Dropdown</span>
                                            </button>
                                            <div className="dropdown-menu" role="menu">
                                                <NavLink id="routeNoShow" tag={Link} to="/noshow/list" className="dropdown-item" title="No Show Request"><i className="fas fa-eye-slash"></i> No Show Request</NavLink>
                                                <NavLink id="routeDriverMessageList" tag={Link} to="/drivermessage/list" className="dropdown-item" title="Driver Message"><i className="fas fa-sms"></i> Driver Message</NavLink>
                                                <NavLink id="routeLoggedDrivers" tag={Link} to="/loggeddrivers/list" className="dropdown-item" title="Logged Drivers"><i className="fas fa-user"></i> Logged Drivers</NavLink>
                                                <NavLink id="routeLoggedVehicles" tag={Link} to="/loggedvehicles/list" className="dropdown-item" title="Logged Vehicles"><i className="fas fa-car"></i> Logged Vehicles</NavLink>
                                                <NavLink id="routeDriverMessge" tag={Link} to="#" className="dropdown-item" onClick={(e) => { this.sendDriverMessageControl(e, null) }} data-toggle="modal" title="Send Message"><i className="fas fa-sms"></i> Send Message</NavLink>
                                                <NavLink id="routeCrewAirlineMessage" tag={Link} to="#" className="dropdown-item" onClick={(e) => { this.sendCrewAirlineMessageControl(e, null) }} data-toggle="modal" title="Send Crew Message"><i className="fas fa-sms"></i> Send Crew Message</NavLink>
                                                <NavLink id="routeTrackLog" tag={Link} to="/gpstrack/list" className="dropdown-item" title="Vehicle Gps Log"><i className="fas fa-sms"></i> Track Log</NavLink>
                                            </div>
                                        </div>
                                    </li>
                                    <NavItem><NavLink id="routeDispatchRefresh" tag={Link} to="#" className="btn btn-block btn-outline-secondary btn-sm" title="Refresh" onClick={(e) => { this.refreshDispatch(e, null) }}><i className="fas fa-sync-alt"></i> Refresh</NavLink></NavItem>
                                    <NavItem><NavLink id="routeDispatchCalendar" tag={Link} to="/dispatch/calendar" className="btn btn-block btn-outline-secondary btn-sm" title="Dispatch Calendar"><i className="fas fa-calendar-alt"></i> Calendar</NavLink></NavItem>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content">
                    <ul className="nav nav-tabs dispatch-nav-tabs" id="custom-content-below-tab" role="tablist">
                        <li className="nav-item">
                            <a className={`nav-link${this.state.isShowDispatchFilter ? ' active' : ''}`} id="dispatcher-tab" data-toggle="pill" href="#dispatcher" role="tab" aria-controls="dispatcher" aria-selected={this.state.isShowDispatchFilter}
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.setState({ isShowDispatchFilter: true });
                                }}
                            ><i className="fas fa-taxi"></i> Dispatch
                                {this.state.totalRideCount > 0 &&
                                    <span className="tab-badge tab-badge-info">{this.state.totalRideCount}</span>
                                }
                            </a>
                        </li>
                        {
                            (session_mappedAccountId1 !== session_accountId
                                && session_mappedAccountId2 !== session_accountId
                                && session_mappedAccountId4 !== session_accountId
                                && session_mappedAccountId5 !== session_accountId
                                && session_mappedAccountId6 !== session_accountId
                                && session_mappedAccountId7 !== session_accountId) ? null :
                                <li className="nav-item">
                                    <a className={`nav-link${!this.state.isShowDispatchFilter ? ' active' : ''}`} id="alert-notification-tab" data-toggle="pill" href="#alert-notification" role="tab" aria-controls="alert-notification" aria-selected={!this.state.isShowDispatchFilter}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            this.setState({ isShowDispatchFilter: false });
                                            this.getAlertNotifications(false);
                                        }}>
                                        <i className="fas fa-bell"></i> Alert &amp; Notifications
                                        {this.state.alertNotificationsSource && this.state.alertNotificationsSource.length > 0 &&
                                            <span className="tab-badge">{this.state.alertNotificationsSource.length}</span>
                                        }
                                    </a>
                                </li>
                        }
                        {/*<li className="nav-item">
                        {/*    <a className="nav-link" id="dispatcher-calendar-vehicle-tab" data-toggle="pill" href="#dispatcher-calendar-vehicle" role="tab" aria-controls="dispatcher-calendar-vehicle" aria-selected="false">Vehicle Assign</a>*/}
                        {/*</li>*/}
                        {/*<li className="nav-item">*/}
                        {/*    <a className="nav-link" id="dispatcher-calendar-driver-tab" data-toggle="pill" href="#dispatcher-calendar-driver" role="tab" aria-controls="dispatcher-calendar-driver" aria-selected="false">Driver Assign</a>*/}
                        {/*</li>*/}
                        {/*<li className="nav-item">*/}
                        {/*    <a className="nav-link" id="dispatcher-tracking-tab" data-toggle="pill" href="#dispatcher-tracking" role="tab" aria-controls="dispatcher-tracking" aria-selected="false">Tracking</a>*/}
                        {/*</li>*/}
                        {/*<li className="nav-item">*/}
                        {/*    <a className="nav-link" id="dispatcher-noshow-tab" data-toggle="pill" href="#dispatcher-noshow" role="tab" aria-controls="dispatcher-noshow" aria-selected="false" onClick={(e) => { this.handleNoshowReservations(e, null) }}>NoShow Requests</a>*/}
                        {/*</li>*/}
                        {/*<li className="nav-item">*/}
                        {/*    <a className="nav-link" id="dispatcher-notification-tab" data-toggle="pill" href="#dispatcher-notification" role="tab" aria-controls="dispatcher-notification" aria-selected="false" onClick={(e) => { this.handleNoshowReservations(e, null) }}>Notifications</a>*/}
                        {/*</li>*/}
                        <DispatchFilterBar
                            isShowDispatchFilter={this.state.isShowDispatchFilter}
                            searchFromDate={this.state.searchFromDate}
                            searchToDate={this.state.searchToDate}
                            isVisiblePickupSchedules={this.state.isVisiblePickupSchedules}
                            isShowPickupSchedules={this.state.isShowPickupSchedules}
                            isShowPending={this.state.isShowPending}
                            isShowInProcess={this.state.isShowInProcess}
                            isShowCompleted={this.state.isShowCompleted}
                            isShowCancelled={this.state.isShowCancelled}
                            isShowAll={this.state.isShowAll}
                            isSearchLoading={this.state.isSearchLoading}
                            gridSearchText={this.state.gridSearchText}
                            onGridSearchChange={this.handleGridSearchChange}
                            onGridSearchPaste={this.handleGridSearchPaste}
                            onGridSearchClear={this.handleGridSearchClear}
                            onInputChange={this.handleInputChange}
                            onFromDateChange={this.handleSearchFromDateChange}
                            onToDateChange={this.handleSearchToDateChange}
                            onSearch={this.handleDispatchSearch}
                            onReset={this.handleReset}
                        />
                    </ul>
                    <div className="tab-content" id="custom-content-below-tabContent" style={{ marginTop: 0 }}>
                        {/*<div className="card">*/}
                        {/*    <div className="card-body mb-0">*/}

                        {/*    </div>*/}
                        {/*</div>*/}
                        <div className={`tab-pane fade${this.state.isShowDispatchFilter ? ' show active' : ''}`}
                         id="dispatcher" role="tabpanel" aria-labelledby="dispatcher-tab">
                            <div className="content">
                                <div className="card card-grid" style={{ marginTop: 0 }}>
                                    <div className="card-body">
                                        <DispatchGrid
                                            ref={(ref) => this.dataGrid = ref}
                                            variant={isCustomDispatchGrid() ? 'custom' : 'standard'}
                                            dataSource={this.state.reservationGridDataSource}
                                            searchPanelText={this.state.gridSearchText}
                                            selectedRowKeys={this.state.selectedRowKeys}
                                            enterKeyAction={this.state.enterKeyAction}
                                            allowToAddDriverWorkingHours={allowToAddDriverWorkingHours}
                                            onToolbarPreparing={this.onToolbarPreparing}
                                            onRowPrepared={isCustomDispatchGrid() ? this.handleCustomRowPrepared : this.handleRowPrepared}
                                            onSelectionChanged={this.handleMultipleRideSelectionChanged}
                                            onOptionChanged={this.handleOptionChange}
                                            onExporting={this.onExporting}
                                            onCellPrepared={this.handleCustomCellPrepared}
                                            renderFilterToolbarItems={this.renderFilterToolbarItems}
                                            pickupTimeSlotId={this.state.selectedPickupTimeSlotId}
                                            crewTypeId={this.state.selectedCrewTypeId}
                                            renderReportingDeBriefingCell={this.renderReportingDeBriefingCell}
                                            renderDetail={this.renderDetail}
                                            toolbarItemRender={this.toolbarItemRender}
                                            socketDataUpdated={this.state.socketDataUpdated}
                                            renderGridCell={this.renderGridCell}
                                            renderDeBriefingCell={this.renderDeBriefingCell}
                                            renderPickupTimeCell={this.renderPickupTimeCell}
                                            renderPickupAddressCell={this.renderPickupAddressCell}
                                            renderDropoffAddressCell={this.renderDropoffAddressCell}
                                            renderFlightInfoCell={this.renderFlightInfoCell}
                                            renderJobIdCell={this.renderJobIdCell}
                                            renderPaxNameCell={this.renderPaxNameCell}
                                        />
                                    </div>
                                </div>
                                <ViewReservationComponent ref="viewReservationModal" />
                                <ReservationHistoryComponent ref="reservationHistoryModal" />
                                <LocateVehicleComponent ref="locateVehicleModal" />
                                <SendMessageComponent ref="SendMessageComponentModel" onSendMessageClose={this.getPreApprovedRideList} refreshDataSource={this.handleSearch} handleRefresh={this.handleRefresh} />
                                <SendAirlineCrewMessageComponent ref="SendAirlineCrewMessageComponentModel" />
                                <ClubReservationsComponent
                                    ref="clubReservationsModal"
                                    serviceVehicles={this.state.serviceVehicles}
                                    serviceDrivers={this.state.serviceDrivers}
                                    vehicleItemRender={this.vehicleItemRender}
                                    driverItemRender={this.driverItemRender}
                                    onAssign={this.assignJob}
                                />
                            </div>
                        </div>
                        {
                            (session_mappedAccountId1 !== session_accountId
                                && session_mappedAccountId2 !== session_accountId
                                && session_mappedAccountId4 !== session_accountId
                                && session_mappedAccountId5 !== session_accountId
                                && session_mappedAccountId6 !== session_accountId
                                && session_mappedAccountId7 !== session_accountId
                            ) ? null :
                                <div className={`tab-pane fade${!this.state.isShowDispatchFilter ? ' show active' : ''}`} id="alert-notification" role="tabpanel" aria-labelledby="alert-notification-tab">
                                    <div className="content">
                                        <div className="card card-grid" style={{ marginTop: 0 }}>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                        <DataGrid
                                                            ref={(ref) => this.dataAlertNotificationGrid = ref}
                                                            id="alert-notification-container"
                                                            name="alertNotificationContainer"
                                                            dataSource={this.state.alertNotificationsSource}
                                                            className="dx-datagrid-height"
                                                            height="100%"
                                                            keyExpr="id"
                                                            columnsAutoWidth={true}
                                                            showColumnLines={true}
                                                            showRowLines={true}
                                                            showBorders={true}
                                                            rowAlternationEnabled={true}
                                                            allowColumnResizing={true}
                                                            columnResizingMode='widget'
                                                            onToolbarPreparing={this.onToolbarPreparingAlertNotification}>

                                                            <Column dataField="id" width={70} caption="Action" allowFiltering={false} allowSorting={false} cellRender={this.renderReatNotificationCell} alignment="center" />
                                                            <Column dataField="readAt" width={170} caption="Status" allowFiltering={false} allowSorting={true} cellRender={this.renderReatAtTimeCell} />
                                                            <Column dataField="changeType" width={140} caption="Change Type" allowFiltering={true} allowSorting={true} cellRender={this.renderChangeTypeCell} />
                                                            <Column dataField="flightNumber" width={85} caption="Flight #" allowFiltering={true} allowSorting={true} />
                                                            <Column dataField="flightTime" width={140} caption="Flight Time" allowFiltering={true} allowSorting={true} format={DateFormat.DateTime24Format} dataType="datetime" />
                                                            {/*<Column dataField="accountName" width={200} caption="Transport Company" allowFiltering={true} allowSorting={true} />*/}
                                                            <Column dataField="employeeNumber" width={110} caption="Employee No" allowFiltering={true} allowSorting={true} />
                                                            <Column dataField="crewName" width={160} caption="Crew Name" allowFiltering={true} allowSorting={true} />
                                                            <Column dataField="rank" width={70} caption="Rank" allowFiltering={true} allowSorting={true} />
                                                            <Column dataField="previousData" width={280} caption="Previous Data" allowFiltering={true} allowSorting={true} />
                                                            <Column dataField="currentData" width={280} caption="Current Data" allowFiltering={true} allowSorting={true} />
                                                            {/*<Column dataField="changeSource" width={150} caption="Change Source" allowFiltering={true} allowSorting={true} />*/}
                                                            <Column dataField="changeTime" width={150} caption="Change Time" allowFiltering={true} allowSorting={true} format={DateFormat.DateTime24Format} dataType="datetime" />
                                                            <Column dataField="readByName" width={150} caption="Read By" allowFiltering={true} allowSorting={true} />

                                                            <Template name="multipleNotifications" render={this.toolbarAlertNotificationItemRender} />
                                                            <ColumnChooser enabled={false} />
                                                            <Grouping autoExpandAll={true} />
                                                            <HeaderFilter visible={true} />
                                                            <Scrolling mode="standard" showScrollbar="always" />
                                                            <Paging enabled={false} />
                                                            <SearchPanel visible={true} highlightCaseSensitive={true} width={240} placeholder="Search..." />
                                                            <Export visible={true} enabled={true} allowExportSelectedData={false} fileName="NotificationLog" />
                                                            <GroupPanel visible={false} />
                                                            {/*<Selection*/}
                                                            {/*    mode="none"*/}
                                                            {/*    selectAllMode={"allPages"}*/}
                                                            {/*    showCheckBoxesMode={"always"}*/}
                                                            {/*/>*/}
                                                        </DataGrid>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        }
                        {/*<div className="tab-pane fade show" id="dispatcher-calendar-vehicle" role="tabpanel" aria-labelledby="dispatcher-calendar-vehicle-tab">*/}
                        {/*    <div className="content">*/}
                        {/*        <div className="card card-grid" style={{ marginTop: 0 }}>*/}
                        {/*            <div className="card-body">*/}
                        {/*                <div className="row">*/}
                        {/*                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">*/}
                        {/*                        <div className="form-group btn-group custom-date-navigator">*/}
                        {/*                            <button type="button" className="btn btn-default btn-sm" onClick={this.prevDate}><i className="fas fa-chevron-left"></i></button>*/}
                        {/*                            <input className="form-control form-control-sm" type="text" value={this.state.currentGPSDisplayDate} onChange={this.handleInputChange} />*/}
                        {/*                            <button type="button" className="btn btn-default btn-sm" onClick={this.nextDate}><i className="fas fa-chevron-right"></i></button>*/}
                        {/*                        </div>*/}
                        {/*                    </div>*/}
                        {/*                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">*/}

                        {/*                        <div className="gps-container">*/}
                        {/*                            {*/}
                        {/*                                this.state.calAvailableVehicles.map((vitem, i) => (*/}
                        {/*                                    <div*/}
                        {/*                                        onDragOver={(e) => { this.handleDragOver(e) }}*/}
                        {/*                                        onDrop={(e) => this.handleOnDrop(e, vitem)}*/}
                        {/*                                        key={i}*/}
                        {/*                                        className="pending-container">*/}
                        {/*                                        <h6><strong>{vitem.displayName}</strong></h6>*/}
                        {/*                                        {this.state.calRideVehicleList && this.state.calRideVehicleList.filter(function (entry) { return entry.status === vitem.status && entry.rideId != "" }).map((ritem, i) => (*/}
                        {/*                                            <div*/}
                        {/*                                                onDragStart={(e) => { this.handleDragStart(e, ritem.rideId) }}*/}
                        {/*                                                key={ritem.rideId}*/}
                        {/*                                                //key={i}*/}
                        {/*                                                draggable*/}
                        {/*                                                className="draggable ride-container">{ritem.text}</div>*/}
                        {/*                                        ))}*/}
                        {/*                                    </div>*/}
                        {/*                                ))*/}
                        {/*                            }*/}
                        {/*                        </div>*/}
                        {/*                    </div>*/}
                        {/*                </div>*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div className="tab-pane fade show" id="dispatcher-calendar-driver" role="tabpanel" aria-labelledby="dispatcher-calendar-driver-tab">*/}
                        {/*    <div className="content">*/}
                        {/*        <div className="card card-grid" style={{ marginTop: 0 }}>*/}
                        {/*            <div className="card-body">*/}
                        {/*                <div className="row">*/}
                        {/*                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">*/}
                        {/*                        <div className="form-group btn-group custom-date-navigator">*/}
                        {/*                            <button type="button" className="btn btn-default btn-sm" onClick={this.prevDate}><i className="fas fa-chevron-left"></i></button>*/}
                        {/*                            <input className="form-control form-control-sm" type="text" value={this.state.currentGPSDisplayDate} onChange={this.handleInputChange} />*/}
                        {/*                            <button type="button" className="btn btn-default btn-sm" onClick={this.nextDate}><i className="fas fa-chevron-right"></i></button>*/}
                        {/*                        </div>*/}
                        {/*                    </div>*/}
                        {/*                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">*/}
                        {/*                        <div className="gps-container">*/}
                        {/*                            {*/}
                        {/*                                this.state.calAvailableDrivers.map((ditem, i) => (*/}
                        {/*                                    <div*/}
                        {/*                                        onDragOver={(e) => { this.handleDragOver(e) }}*/}
                        {/*                                        onDrop={(e) => this.handleOnDriverDrop(e, ditem)}*/}
                        {/*                                        key={i}*/}
                        {/*                                        className="pending-container">*/}
                        {/*                                        <h6><strong>{ditem.driverName}</strong></h6>*/}
                        {/*                                        {this.state.calRideDriverList && this.state.calRideDriverList.filter(function (entry) { return entry.driverId === ditem.driverId && entry.rideId != "" }).map((ritem, i) => (*/}
                        {/*                                            <div*/}
                        {/*                                                onDragStart={(e) => { this.handleDragStart(e, ritem.rideId) }}*/}
                        {/*                                                key={ritem.rideId}*/}
                        {/*                                                //key={i}*/}
                        {/*                                                draggable*/}
                        {/*                                                className="draggable ride-container">{ritem.text}</div>*/}
                        {/*                                        ))}*/}
                        {/*                                    </div>*/}
                        {/*                                ))*/}
                        {/*                            }*/}
                        {/*                        </div>*/}
                        {/*                    </div>*/}
                        {/*                </div>*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div className="tab-pane fade show" id="dispatcher-tracking" role="tabpanel" aria-labelledby="dispatcher-tracking-tab">*/}
                        {/*    <div className="content-wrapper">*/}
                        {/*        <div className="content" style={{ height: 73 + 'vh' }}>*/}
                        {/*            <iframe width="100%" height="100%" frameBorder="0" scrolling="no" allowtransparency="false" src={this.state.trackmapUrl}></iframe>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div className="tab-pane fade show" id="dispatcher-noshow" role="tabpanel" aria-labelledby="dispatcher-noshow-tab">*/}
                        {/*    <NoShowReservationsComponent ref="noShowReservations" />*/}
                        {/*</div>*/}
                        {/*<div className="tab-pane fade show" id="dispatcher-notification" role="tabpanel" aria-labelledby="dispatcher-notification-tab">*/}
                        {/*    <NotificationComponent ref="notificationData" />*/}
                        {/*</div>*/}
                    </div>
                </div>
                <aside className="control-sidebar control-sidebar-light p-3">
                    <h5>Advanced Search</h5>
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="form-group">
                                <label htmlFor="">Ride Id</label>
                                <input type="text" className="form-control form-control-sm" name="rideId" placeholder="Enter ride id" value={this.state.rideId} onChange={this.handleInputChange} />
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="form-group">
                                <label>Driver</label>
                                <SelectBox
                                    dataSource={this.state.driverList?.length > 0 ? this.state.driverList : []}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    placeholder="Select driver"
                                    name="id"
                                    defaultValue={0}
                                    value={this.state.driverId}
                                    displayExpr='name'
                                    valueExpr='id'
                                    onSelectionChanged={this.handleDriverChange}
                                    showClearButton={true}
                                    disabled={false}
                                    searchEnabled={true}
                                />
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="form-group">
                                <label>Vehicle Type</label>
                                <DropDownBox
                                    value={this.state.filterVehicleTypeList}
                                    valueExpr="vehicleTypeId"
                                    deferRendering={false}
                                    displayExpr="apiVehicleTypeDescription"
                                    placeholder="Select vehicle type..."
                                    showClearButton={true}
                                    dataSource={this.state.vehicleTypeList}
                                    onValueChanged={this.syncDataGridVehicleTypeSelection}
                                    contentRender={this.dataGridVehicleTypeRender}
                                />
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="form-group">
                                <label>Vehicles</label>
                                <DropDownBox
                                    value={this.state.filterVehicleList}
                                    valueExpr="id"
                                    deferRendering={false}
                                    displayExpr="name"
                                    placeholder="Select vehicle ..."
                                    showClearButton={true}
                                    dataSource={this.state.vehicleList}
                                    onValueChanged={this.syncDataGridVehicleSelection}
                                    contentRender={this.dataGridVehicleRender}
                                />
                            </div>
                        </div>
                        <div id="advanceSearch" className="container">
                            <div className="row">
                                {/*<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">*/}
                                {/*    <div className="form-group">*/}
                                {/*        <label>Status</label>*/}
                                {/*        <DropDownBox*/}
                                {/*            value={this.state.filterStatusList}*/}
                                {/*            valueExpr="id"*/}
                                {/*            deferRendering={false}*/}
                                {/*            displayExpr="name"*/}
                                {/*            placeholder="Select status..."*/}
                                {/*            showClearButton={true}*/}
                                {/*            dataSource={this.state.statusList}*/}
                                {/*            onValueChanged={this.syncDataGridStatusSelection}*/}
                                {/*            contentRender={this.dataGridStatusRender}*/}
                                {/*        />*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Vehicle Group Type</label>
                                        <DropDownBox
                                            value={this.state.filterVehicleGroupTypeList}
                                            valueExpr="id"
                                            deferRendering={false}
                                            displayExpr="name"
                                            placeholder="Select vehicle group..."
                                            showClearButton={true}
                                            dataSource={this.state.vehicleGroupTypesList}
                                            onValueChanged={this.syncDataGridVehicleGroupSelection}
                                            contentRender={this.dataGridVehicleGroupRender}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Location</label>
                                        <SelectBox
                                            dataSource={this.state.locationList?.length > 0 ? this.state.locationList : []}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select location"
                                            name="locationId"
                                            defaultValue={0}
                                            value={this.state.locationId}
                                            displayExpr='locationName'
                                            valueExpr='locationId'
                                            onSelectionChanged={this.handleLocationChange}
                                            showClearButton={true}
                                            disabled={false}
                                            searchEnabled={true}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 displayNone">
                                    <div className="form-group">
                                        <br />
                                        <span className="form-check">
                                            <input className="form-check-input" type="checkbox" id="isLive" name="isLive" checked={this.state.isLive} onChange={this.handleInputChange} />
                                            <label className="form-check-label" htmlFor="isLive"> Live</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="checkbox" id="isInHouse" name="isInHouse" checked={this.state.isInHouse} onChange={this.handleInputChange} />
                                            <label className="form-check-label" htmlFor="isInHouse"> In-House</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="checkbox" id="isFarmIn" name="isFarmIn" checked={this.state.isFarmIn} onChange={this.handleInputChange} />
                                            <label className="form-check-label" htmlFor="isFarmIn"> Farm In</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="checkbox" id="isFarmOut" name="isFarmOut" checked={this.state.isFarmOut} onChange={this.handleInputChange} />
                                            <label className="form-check-label" htmlFor="isFarmOut"> Farm out</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left"><br />
                            <button type="submit" className="btn btn-success btn-sm" onClick={this.handleSearch} data-widget="control-sidebar" data-slide="true">
                                {this.state.isAdvancedSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin" title="In-process"></i> In-process</span>}
                                {!this.state.isAdvancedSubmited && <span title="Search"><i className="fas fa-search" title="Search"></i> Adavanced Search</span>}
                            </button>&nbsp;&nbsp;
                            <button type="submit" className="btn btn-custom-gray btn-sm" data-widget="control-sidebar" data-slide="true" onClick={this.handleClearSearch} title="Clear"><i className="fas fa-eraser"></i> Close</button>
                        </div>
                    </div>
                </aside>
                {/*<LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    position={position}
                    visible={this.state.loadPanelVisible}
                    showIndicator={true}
                    shading={false}
                    showPane={true}
                    closeOnOutsideClick={false}
                />*/}
                <Popup
                    visible={this.state.addressPopupVisible}
                    onHiding={() => this.setState({ addressPopupVisible: false })}
                    dragEnabled={false}
                    closeOnOutsideClick={true}
                    showTitle={true}
                    title={this.state.addressPopupTitle}
                    width={360}
                    height="auto"
                    showCloseButton={true}
                    contentRender={() => (
                        <div className="address-popup-content">
                            <i className="fas fa-map-marker-alt address-popup-marker"></i>
                            <span>{this.state.addressPopupText}</span>
                        </div>
                    )}
                />
            </div>
        );
    }

    //dataGridStatusRender() {
    //    return (
    //        <DataGrid
    //            dataSource={this.state.statusList}
    //            id="grid-container"
    //            keyExpr="id"
    //            hoverStateEnabled={true}
    //            selectedRowKeys={this.state.filterStatusList}
    //            onSelectionChanged={this.handleStatusChange}
    //            ref={ref => this.dataGrid = ref}>
    //            <Column dataField="name" caption="Location" />
    //            <Selection mode="multiple" />
    //            <Scrolling mode="both" />
    //            <Paging enabled={true} pageSize={5} />
    //            <FilterRow visible={true} />
    //        </DataGrid>
    //    );
    //}

    dataGridVehicleGroupRender() {
        return (
            <DataGrid
                dataSource={this.state.vehicleGroupTypesList}
                id="grid-container"
                keyExpr="id"
                hoverStateEnabled={true}
                selectedRowKeys={this.state.filterVehicleGroupTypeList}
                onSelectionChanged={this.handleVehicleGroupTypeChange}
                ref={ref => this.dataGrid = ref}>
                <Column dataField="name" caption="Vehicle Group" />
                <Selection mode="multiple" />
                <Scrolling mode="both" />
                <Paging enabled={true} pageSize={5} />
                <FilterRow visible={true} />
            </DataGrid>
        );
    }

    dataGridVehicleTypeRender() {
        return (
            <DataGrid
                dataSource={this.state.vehicleTypeList}
                id="grid-container"
                keyExpr="vehicleTypeId"
                hoverStateEnabled={true}
                selectedRowKeys={this.state.filterVehicleTypeList}
                onSelectionChanged={this.handleVehicleTypeChange}
                ref={ref => this.dataGrid = ref}>
                <Column dataField="apiVehicleTypeDescription" caption="Vehicle Type" />
                <Selection mode="multiple" />
                <Scrolling mode="both" />
                <Paging enabled={true} pageSize={5} />
                <FilterRow visible={true} />
            </DataGrid>
        );
    }

    dataGridVehicleRender() {
        return (
            <DataGrid
                dataSource={this.state.vehicleList}
                id="grid-container"
                keyExpr="id"
                hoverStateEnabled={true}
                selectedRowKeys={this.state.filterVehicleList}
                onSelectionChanged={this.handleVehicleChange}
                ref={ref => this.dataGrid = ref}>
                <Column dataField="name" caption="Vehicle" />
                <Selection mode="multiple" />
                <Scrolling mode="both" />
                <Paging enabled={true} pageSize={8} />
                <FilterRow visible={true} />
            </DataGrid>
        );
    }
}